module.exports = {
    AU: {
        EN: {
            SEARCH_PAGE: {
                HEADING: "View my order",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Order Number",
                    ERROR_REQUIRED: "Order number is required",
                    ERROR_INVALID_FORMAT: "Invalid format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Forgot your order number",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Order not found"
                },
                SEARCH_BUTTON_TEXT: "View"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Forgot my order number",
                SUBHEADING: "Please provide your email address.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                SEND_BUTTON_TEXT: "Send email",
                BACK_BUTTON_TEXT: "Back",
                EMAIL_SENT: "An order summary email has been sent.",
                EMAIL_NOT_FOUND: "No orders for this email address"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Order",
                    ORDERED_ON: "Ordered on",
                    BACK_TO_SEARCH: "Back to search"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Shipping Address"
                    },
                    TRACKING: {
                        HEADING: "Tracking Information",
                        TRACKING_BUTTON_MESSAGE: "Track my shipment",
                        SHIPMENT_PENDING_MESSAGE: "Shipment pending"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Order Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TITLE: "Refund",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATED",
                            ACTIVE: "CREATED"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTHORIZED",
                            ACTIVE: "AUTHORIZING"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELLED",
                            ACTIVE: "CANCELLED"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESSED",
                            ACTIVE: "PROCESSING"
                        },
                        SHIPPED: {
                            COMPLETED: "SHIPPED",
                            ACTIVE: "SHIPPING"
                        },
                        DELIVERED: {
                            COMPLETED: "DELIVERED",
                            ACTIVE: "DELIVERING"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNED",
                            ACTIVE: "RETURNING"
                        },
                        REFUNDED: {
                            COMPLETED: "REFUNDED",
                            ACTIVE: "REFUNDING"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "This order was cancelled on"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "This order was refunded"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Waiting for funds to be collected from finance institution"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Refunded Items"
                    },
                    PROTECTION: {
                        TITLE: "Protection Items"
                    },
                    EGIFTCARDS: {
                        TITLE: "eGift Cards"
                    },
                    VIEW_ITEM: "View item"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "For any other inquiries, please go to"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancel Order",
                        SUBHEADING: "Are you sure you want to cancel your order?",
                        ERROR_FAILED: "There was a problem with order cancelation.",
                        SUCCESS_MESSAGE: "Order has been cancelled.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancel Order Items",
                        SUBHEADING: "Select items you would like to cancel.",
                        ERROR_FAILED: "There was a problem with items cancelation.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Items have been cancelled.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Order has been cancelled.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Cancel Order Items",
                            SUBHEADING_CANCEL_ITEMS: "Are you sure you want to cancel selected items?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Are you sure you want to cancel your order?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Return Order",
                        SUBHEADING: "Are you sure you want to return your order?",
                        ERROR_FAILED: "There was a problem with creating order return request.",
                        SUCCESS_MESSAGE: "Return order request was created.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Return Order Items",
                        SUBHEADING: "Select items you would like to return.",
                        ERROR_FAILED: "There was a problem with creating items return request.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Return items request was created.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Return Order Items",
                            SUBHEADING: "Are you sure you want to return selected items?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generate Order Invoice",
                    SUBHEADING: "Please input any optional tax information.",
                    SUCCESS_MESSAGE: "Order invoice has been sent to your email address.",
                    ERROR_FAILED: "Failed to generate order invoice.",
                    ADDITIONAL_TAX_INFO_HEADER: "Additional Tax Info"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Related Items",
                        SUB_HEADING: "Shop for items recommended to you."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Recommended Items",
                        SUB_HEADING: "Browse for more items available for you."
                    }
                },
                MENU: {
                    INVOICE: "Invoice",
                    CANCEL_ITEMS: "Cancel Items",
                    CANCEL_ORDER: "Cancel Order",
                    RETURN_ITEMS: "Return Items",
                    RETURN_ORDER: "Return Order",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Request Assistance",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA request was created"
            },
            MISC: {
                YES: "Yes",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Preorder",
                CANCEL: "Cancel",
                CLOSE: "Close",
                SUBMIT: "Submit",
                REFRESH: "Refresh"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "There was a problem getting your order information",
                DESCRIPTION: "Sorry! We were unable to get information about your order. Please try again.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE NOT FOUND",
                DESCRIPTION: "Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            DATA_CONFLICT: {
                HEADING: "Order Updates Available",
                SUB_HEADING: "Order information has been updated. Please refresh the order page to view the latest information"
            }
        }
    },
    CAEN: {
        EN: {
            SEARCH_PAGE: {
                HEADING: "View my order",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Order Number",
                    ERROR_REQUIRED: "Order number is required",
                    ERROR_INVALID_FORMAT: "Invalid format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Forgot your order number",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Order not found"
                },
                SEARCH_BUTTON_TEXT: "View"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Forgot my order number",
                SUBHEADING: "Please provide your email address.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                SEND_BUTTON_TEXT: "Send email",
                BACK_BUTTON_TEXT: "Back",
                EMAIL_SENT: "An order summary email has been sent.",
                EMAIL_NOT_FOUND: "No orders for this email address"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Order",
                    ORDERED_ON: "Ordered on",
                    BACK_TO_SEARCH: "Back to search"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Shipping Address"
                    },
                    TRACKING: {
                        HEADING: "Tracking Information",
                        TRACKING_BUTTON_MESSAGE: "Track my shipment",
                        SHIPMENT_PENDING_MESSAGE: "Shipment pending"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Order Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TITLE: "Refund",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATED",
                            ACTIVE: "CREATED"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTHORIZED",
                            ACTIVE: "AUTHORIZING"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELLED",
                            ACTIVE: "CANCELLED"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESSED",
                            ACTIVE: "PROCESSING"
                        },
                        SHIPPED: {
                            COMPLETED: "SHIPPED",
                            ACTIVE: "SHIPPING"
                        },
                        DELIVERED: {
                            COMPLETED: "DELIVERED",
                            ACTIVE: "DELIVERING"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNED",
                            ACTIVE: "RETURNING"
                        },
                        REFUNDED: {
                            COMPLETED: "REFUNDED",
                            ACTIVE: "REFUNDING"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "This order was cancelled on"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "This order was refunded"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Waiting for funds to be collected from finance institution"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Refunded Items"
                    },
                    PROTECTION: {
                        TITLE: "Protection Items"
                    },
                    EGIFTCARDS: {
                        TITLE: "eGift Cards"
                    },
                    VIEW_ITEM: "View item"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "For any other inquiries, please go to"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancel Order",
                        SUBHEADING: "Are you sure you want to cancel your order?",
                        ERROR_FAILED: "There was a problem with order cancelation.",
                        SUCCESS_MESSAGE: "Order has been cancelled.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancel Order Items",
                        SUBHEADING: "Select items you would like to cancel.",
                        ERROR_FAILED: "There was a problem with items cancelation.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Items have been cancelled.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Order has been cancelled.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Cancel Order Items",
                            SUBHEADING_CANCEL_ITEMS: "Are you sure you want to cancel selected items?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Are you sure you want to cancel your order?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Return Order",
                        SUBHEADING: "Are you sure you want to return your order?",
                        ERROR_FAILED: "There was a problem with creating order return request.",
                        SUCCESS_MESSAGE: "Return order request was created.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Return Order Items",
                        SUBHEADING: "Select items you would like to return.",
                        ERROR_FAILED: "There was a problem with creating items return request.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Return items request was created.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Return Order Items",
                            SUBHEADING: "Are you sure you want to return selected items?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generate Order Invoice",
                    SUBHEADING: "Please input any optional tax information.",
                    SUCCESS_MESSAGE: "Order invoice has been sent to your email address.",
                    ERROR_FAILED: "Failed to generate order invoice.",
                    ADDITIONAL_TAX_INFO_HEADER: "Additional Tax Info"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Related Items",
                        SUB_HEADING: "Shop for items recommended to you."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Recommended Items",
                        SUB_HEADING: "Browse for more items available for you."
                    }
                },
                MENU: {
                    INVOICE: "Invoice",
                    CANCEL_ITEMS: "Cancel Items",
                    CANCEL_ORDER: "Cancel Order",
                    RETURN_ITEMS: "Return Items",
                    RETURN_ORDER: "Return Order",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Request Assistance",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA request was created"
            },
            MISC: {
                YES: "Yes",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Preorder",
                CANCEL: "Cancel",
                CLOSE: "Close",
                SUBMIT: "Submit",
                REFRESH: "Refresh"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "There was a problem getting your order information",
                DESCRIPTION: "Sorry! We were unable to get information about your order. Please try again.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE NOT FOUND",
                DESCRIPTION: "Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            DATA_CONFLICT: {
                HEADING: "Order Updates Available",
                SUB_HEADING: "Order information has been updated. Please refresh the order page to view the latest information"
            }
        },
        FR: {
            SEARCH_PAGE: {
                HEADING: "Voir ma commande",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Numéro de commande",
                    ERROR_REQUIRED: "Le numéro de commande est requis",
                    ERROR_INVALID_FORMAT: "Format invalide"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adresse email",
                    ERROR_REQUIRED: "L'adresse email est requise",
                    ERROR_INVALID: "L'adresse email est incorrecte"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Numéro de commande oublié",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Commande non trouvée"
                },
                SEARCH_BUTTON_TEXT: "Voir la commande"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Numéro de commande oublié",
                SUBHEADING: "SVP donnez votre adresse email.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adresse email",
                    ERROR_REQUIRED: "L'adresse email est requise",
                    ERROR_INVALID: "L'adresse email est incorrecte"
                },
                SEND_BUTTON_TEXT: "Envoyez email",
                BACK_BUTTON_TEXT: "Retour",
                EMAIL_SENT: "Une confirmation de commande a été envoyée par email",
                EMAIL_NOT_FOUND: "Il n'y a pas de numéro de commande avec cette adresse email"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Commande",
                    ORDERED_ON: "Commandez le",
                    BACK_TO_SEARCH: "Retour à la recherche"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Adresse de livraison"
                    },
                    TRACKING: {
                        HEADING: "Informations de suivi",
                        TRACKING_BUTTON_MESSAGE: "Suivi de mon colis",
                        SHIPMENT_PENDING_MESSAGE: "Livraison en attente"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Récapitulatif de la commande",
                        ITEMS_SUBTOTAL_TITLE: "Sous-total des articles",
                        SHIPPING_TITLE: "Expédition et manutention",
                        DISCOUNT_TITLE: "Rabais",
                        TAXES_TITLE: "Total des taxes",
                        REFUND_TITLE: "Remboursement",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CRÉÉ",
                            ACTIVE: "CRÉÉ"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTORISÉ",
                            ACTIVE: "AUTORISATION"
                        },
                        CANCELLED: {
                            COMPLETED: "ANNULÉ",
                            ACTIVE: "ANNULÉ"
                        },
                        PROCESSED: {
                            COMPLETED: "TRAITÉ",
                            ACTIVE: "TRAITEMENT"
                        },
                        SHIPPED: {
                            COMPLETED: "ENVOYÉ",
                            ACTIVE: "EXPÉDITION"
                        },
                        DELIVERED: {
                            COMPLETED: "LIVRÉ",
                            ACTIVE: "LIVRAISON"
                        },
                        RETURNED: {
                            COMPLETED: "RETOURNÉ",
                            ACTIVE: "RETOUR"
                        },
                        REFUNDED: {
                            COMPLETED: "REMBOURSÉ",
                            ACTIVE: "REMBOURSEMENT"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Cette commande a été annulée le"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Cette commande a été remboursée"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "En attente de la réception des fonds auprès de l'institution financière"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Articles remboursés"
                    },
                    EGIFTCARDS: {
                        TITLE: "e-Cartes cadeaux"
                    },
                    VIEW_ITEM: "Voir l'article"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "Pour toute autre requête, rendez-vous sur"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Annuler la commande",
                        SUBHEADING: "Voulez-vous vraiment annuler votre commande?",
                        ERROR_FAILED: "Un problème est survenu lors de la suppression commande.",
                        SUCCESS_MESSAGE: "La commande a été annulée.",
                        EGIFTCARDS_PRESENT_MESSAGE:
                            "* La commande contient des e-Cartes cadeaux qui ne peuvent pas être annulées car il s'agit d'une vente finale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Annuler des articles de la commande",
                        SUBHEADING: "Sélectionnez les articles que vous souhaitez supprimer.",
                        ERROR_FAILED: "Un problème est survenu lors de la suppression d’articles.",
                        ERROR_CALCULATION_FAILED: "Un problème est survenu lors du calcul du remboursement.",
                        SUCCESS_MESSAGE: "Les articles ont bien été supprimés.",
                        SUCCESS_MESSAGE_FULL_ORDER: "La commande a été annulée.",
                        SELECT_ALL_ITEMS: "Sélectionner tous les articles",
                        CONFIRMATION: {
                            HEADING: "Annuler des articles de la commande",
                            SUBHEADING_CANCEL_ITEMS: "Êtes-vous sûr(e) de vouloir annuler les articles sélectionnés?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Voulez-vous vraiment annuler votre commande?"
                        },
                        ITEMS_HEADER: "Articles",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Sélectionnez au moins un article"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE:
                            "* La commande contient des e-Cartes cadeaux qui ne peuvent pas être annulées car il s'agit d'une vente finale"
                    },
                    REASON_HEADER: "Raison",
                    ERRORS: {
                        REASON_REQUIRED: "Une raison est requise"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "J’ai acheté le mauvais article",
                        NO_LONGER_NEEDED: "Je n’en ai plus besoin",
                        BETTER_PRICE: "J’ai trouvé un meilleur prix",
                        MISTAKE: "J’ai passé la commande par erreur"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Résumé du remboursement",
                        ITEMS_SUBTOTAL_TITLE: "Sous-total des articles",
                        SHIPPING_TITLE: "Expédition et manutention",
                        DISCOUNT_TITLE: "Rabais",
                        TAXES_TITLE: "Total des taxes",
                        REFUND_TOTAL_TITLE: "Total du remboursement"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Retourner la commande",
                        SUBHEADING: "Voulez-vous vraiment retourner votre commande ?",
                        ERROR_FAILED: "Une erreur s'est produite lors de la création de la demande de retour.",
                        SUCCESS_MESSAGE: "La demande de retour a été crée.",
                        EGIFTCARDS_PRESENT_MESSAGE:
                            "* La commande contient des e-Cartes cadeaux qui ne peuvent pas être retournées car il s'agit d'une vente finale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Retourner des articles",
                        SUBHEADING: "Sélectionnez les articles que vous souhaitez retourner.",
                        ERROR_FAILED: "Une erreur s'est produite lors de la création de la demande de retour.",
                        ERROR_CALCULATION_FAILED: "Un problème est survenu lors du calcul du remboursement.",
                        SUCCESS_MESSAGE: "La demande de retour a été crée.",
                        SELECT_ALL_ITEMS: "Sélectionner tous les articles",
                        CONFIRMATION: {
                            HEADING: "Retourner des articles",
                            SUBHEADING: "Voulez-vous vraiment retourner les articles sélectionnés ?"
                        },
                        ITEMS_HEADER: "Articles",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Au moins un article est requis"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE:
                            "* La commande contient des e-Cartes cadeaux qui ne peuvent pas être retournées car il s'agit d'une vente finale"
                    },
                    REASON_HEADER: "Raison",
                    ERRORS: {
                        REASON_REQUIRED: "La raison est requise"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "J'ai acheté le mauvais article",
                        NO_LONGER_NEEDED: "Je n'ai plus besoin de cet article",
                        BETTER_PRICE: "J'ai trouvé un prix plus avantageux",
                        MISTAKE: "J'ai passé la commande par erreur"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Résumé du remboursement",
                        ITEMS_SUBTOTAL_TITLE: "Sous-total des articles",
                        SHIPPING_TITLE: "Expédition et manutention",
                        DISCOUNT_TITLE: "Rabais",
                        TAXES_TITLE: "Total des taxes",
                        REFUND_TOTAL_TITLE: "Total du remboursement"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Raison",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Sélectionner tous les articles",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "La raison est requise",
                        CANCEL_ITEMS_REQUIRED: "Au moins un article est requis"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Générer une facture de commande",
                    SUBHEADING: "Veuillez indiquer vos informations fiscales (optionnel).",
                    SUCCESS_MESSAGE: "La facture relative à votre commande a été envoyée sur votre adresse e-mail.",
                    ERROR_FAILED: "Échec de la génération d’une facture de commande.",
                    ADDITIONAL_TAX_INFO_HEADER: "Informations fiscales additionnelles"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Recevoir par courriel les détails des e-Cartes cadeaux",
                    SUBHEADING:
                        "Le courriel des détails des e-Cartes cadeaux sera envoyé à l'adresse courriel indiquée dans la commande. Voulez vous procéder?",
                    SUCCESS_MESSAGE: "Le courrier électronique a été envoyé",
                    ERROR_FAILED: "Échec de l'envoi du courriel des e-Cartes cadeaux"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Articles similaires",
                        SUB_HEADING: "Magasinez les articles recommandés pour vous."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Articles recommandés",
                        SUB_HEADING: "Magasinez les articles recommandés pour vous."
                    }
                },
                MENU: {
                    INVOICE: "Facture",
                    CANCEL_ITEMS: "Annuler les articles",
                    CANCEL_ORDER: "Annuler la commande",
                    RETURN_ITEMS: "Articles à retourner",
                    RETURN_ORDER: "Retourner la commande",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Demande d'assistance",
                    SEND_EGIFTCARDS_EMAIL: "Obtenez les détails des e-Cartes cadeaux"
                },
                RMA_TITLE: "La demande RMA a été créée"
            },
            MISC: {
                YES: "Oui",
                NO: "Non",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "PRÉ-COMMANDE",
                CANCEL: "Annuler",
                CLOSE: "Fermer",
                SUBMIT: "Soumettre",
                REFRESH: "Actualiser"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Nous avons un ennui à récupérer vos informations de commande.",
                DESCRIPTION: "Désolé! Nous n'avons pas réussi à récupérer les informations de votre commande. SVP essayez à nouveau.",
                HELP_MESSAGE: "Voyez-vous toujours ce message? Allez sur"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE INTROUVABLE",
                DESCRIPTION: "Désolé! La page recherchée n'existe pas, ou est temporairement indisponible.",
                HELP_MESSAGE: "Voyez-vous toujours ce message? Allez sur"
            },
            DATA_CONFLICT: {
                HEADING: "Mises à jour concernant la commande disponibles",
                SUB_HEADING:
                    "Les informations de la commande ont été mises à jour. Veuillez actualiser la page de la commande pour consulter les dernières informations."
            }
        }
    },
    DE: {},
    ES: {
        ES: {
            SEARCH_PAGE: {
                HEADING: "Ver mi pedido",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Número de pedido",
                    ERROR_REQUIRED: "El número del pedido es necesario",
                    ERROR_INVALID_FORMAT: "Formato inválido"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Dirección de email",
                    ERROR_REQUIRED: "Dirección de email es necesario",
                    ERROR_INVALID: "Dirección de email es invalido"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Olvidó el número de su pedido",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Pedido no encontrado"
                },
                SEARCH_BUTTON_TEXT: "Ver pedido"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Olvide el número de mi pedido",
                SUBHEADING: "Por favor provea su email.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Dirección de email",
                    ERROR_REQUIRED: "Dirección de email es necesario",
                    ERROR_INVALID: "Dirección de email es invalido"
                },
                SEND_BUTTON_TEXT: "Enviar email",
                BACK_BUTTON_TEXT: "Regresar a búsqueda",
                EMAIL_SENT: "Un resumen de su pedido ha sido enviado por email.",
                EMAIL_NOT_FOUND: "No hay pedidos para este email"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Pedido",
                    ORDERED_ON: "Pedido en",
                    BACK_TO_SEARCH: "Regresar"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Dirección de envío"
                    },
                    TRACKING: {
                        HEADING: "Información de seguimiento",
                        TRACKING_BUTTON_MESSAGE: "Rastrear mi envío",
                        SHIPMENT_PENDING_MESSAGE: "Envío pendiente"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Resumen de pedido",
                        ITEMS_SUBTOTAL_TITLE: "Subtotal de articulo(s)",
                        SHIPPING_TITLE: "Envío y manipulación",
                        DISCOUNT_TITLE: "Descuento",
                        TAXES_TITLE: "Total de impuestos",
                        REFUND_TITLE: "Reembolso",
                        GRAND_TOTAL_TITLE: "Total general"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREADO",
                            ACTIVE: "CREADO"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTORIZADO",
                            ACTIVE: "AUTORIZANDO"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELADO",
                            ACTIVE: "CANCELADO"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESADO",
                            ACTIVE: "PROCESANDO"
                        },
                        SHIPPED: {
                            COMPLETED: "ENVIADO",
                            ACTIVE: "ENVÍO"
                        },
                        DELIVERED: {
                            COMPLETED: "ENTREGADO",
                            ACTIVE: "ENTREGA"
                        },
                        RETURNED: {
                            COMPLETED: "REGRESADO",
                            ACTIVE: "DEVOLUCIÓN"
                        },
                        REFUNDED: {
                            COMPLETED: "REEMBOLSADO",
                            ACTIVE: "REEMBOLSO"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Este pedido fue cancelado en"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Este pedido fue reembolsado"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "En espera a que los fondos se recauden de la institución financiera"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Artículos reembolsados"
                    },
                    VIEW_ITEM: "Ver artículo"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "Si tienes alguna otra pregunta, dirígete a"
                },

                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancelar el pedido",
                        SUBHEADING: "¿Esta seguro que quiere cancelar su pedido?",
                        ERROR_FAILED: "Se ha producido un problema con la cancelación del pedido.",
                        SUCCESS_MESSAGE: "El pedido se ha cancelado.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancelar artículos del pedido",
                        SUBHEADING: "Selecciona los artículos que deseas cancelar.",
                        ERROR_FAILED: "Se ha producido un problema con la cancelación de los artículos.",
                        ERROR_CALCULATION_FAILED: "Se ha producido un problema con el cálculo del reembolso.",
                        SUCCESS_MESSAGE: "Los artículos se han cancelado.",
                        SUCCESS_MESSAGE_FULL_ORDER: "El pedido se ha cancelado.",
                        SELECT_ALL_ITEMS: "Seleccionar todos los artículos",
                        CONFIRMATION: {
                            HEADING: "Cancelar artículos del pedido",
                            SUBHEADING_CANCEL_ITEMS: "¿Seguro que deseas cancelar los artículos seleccionados?",
                            SUBHEADING_CANCEL_FULL_ORDER: "¿Esta seguro que quiere cancelar su pedido?"
                        },
                        ITEMS_HEADER: "Artículos",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Debes seleccionar al menos uno"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Motivo",
                    ERRORS: {
                        REASON_REQUIRED: "Se requiere un motivo"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Compré el artículo incorrecto",
                        NO_LONGER_NEEDED: "Ya no lo necesito",
                        BETTER_PRICE: "Lo he encontrado a mejor precio",
                        MISTAKE: "Realicé el pedido por equivocación"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Resumen del reembolso",
                        ITEMS_SUBTOTAL_TITLE: "Subtotal de articulo(s)",
                        SHIPPING_TITLE: "Envío y manipulación",
                        DISCOUNT_TITLE: "Descuento",
                        TAXES_TITLE: "Total de impuestos",
                        REFUND_TOTAL_TITLE: "Total del reembolso"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Devolver pedido",
                        SUBHEADING: "¿Seguro que quiere devolver el pedido?",
                        ERROR_FAILED: "Ha habido un problema al crear la solicitud de devolución.",
                        SUCCESS_MESSAGE: "Se ha creado la solicitud de devolución.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Devolver pedido Artículos",
                        SUBHEADING: "Selecciona los artículos que quieras devolver.",
                        ERROR_FAILED: "Ha habido un problema al crear la solicitud de devolución.",
                        ERROR_CALCULATION_FAILED: "Ha habido un problema al calcular el reembolso.",
                        SUCCESS_MESSAGE: "Se ha creado la solicitud de devolución.",
                        SELECT_ALL_ITEMS: "Seleccionar todos los artículos",
                        CONFIRMATION: {
                            HEADING: "Devolver pedido Artículos",
                            SUBHEADING: "¿Seguro que quiere devolver los artículos seleccionados?"
                        },
                        ITEMS_HEADER: "Artículos",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Es obligatorio al menos un artículo"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Motivo",
                    ERRORS: {
                        REASON_REQUIRED: "El motivo es obligatorio"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "He comprado el artículo incorrecto",
                        NO_LONGER_NEEDED: "Ya no lo necesito",
                        BETTER_PRICE: "He encontrado un precio mejor",
                        MISTAKE: "Lo he pedido por error"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Resumen del reembolso",
                        ITEMS_SUBTOTAL_TITLE: "Subtotal de articulo(s)",
                        SHIPPING_TITLE: "Envío y manipulación",
                        DISCOUNT_TITLE: "Descuento",
                        TAXES_TITLE: "Total de impuestos",
                        REFUND_TOTAL_TITLE: "Total del reembolso"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generar factura del pedido",
                    SUBHEADING: "Introduce la información fiscal opcional.",
                    SUCCESS_MESSAGE: "La factura del pedido se ha enviado a tu dirección de correo electrónico.",
                    ERROR_FAILED: "No se ha podido generar la factura del pedido.",
                    ADDITIONAL_TAX_INFO_HEADER: "Información fiscal adicional"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Artículos relacionados",
                        SUB_HEADING: "Compre artículos recomendados a usted."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Artículos recomendados",
                        SUB_HEADING: "Compre artículos recomendados a usted."
                    }
                },
                MENU: {
                    INVOICE: "Factura",
                    CANCEL_ITEMS: "Cancelar artículos",
                    CANCEL_ORDER: "Cancelar pedido",
                    RETURN_ITEMS: "Devolver artículos",
                    RETURN_ORDER: "Devolver pedido",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Solicitar asistencia",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "Se ha creado una solicitud de RMA"
            },
            MISC: {
                YES: "Si",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Preorder",
                CANCEL: "Cancelar",
                CLOSE: "Cerrar",
                SUBMIT: "Enviar",
                REFRESH: "Refrescar"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Hubo un problema obteniendo la información de su orden",
                DESCRIPTION: "¡Disculpe! No pudimos obtener la información de su orden. Por favor intente de nuevo.",
                HELP_MESSAGE: "¿Continúa viendo este mensaje? Vaya a"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGINA NO ENCONTRADA",
                DESCRIPTION: "¡Disculpe! La página que esta intentando encontrar no existe, o no esta disponible temporalmente.",
                HELP_MESSAGE: "¿Continúa viendo este mensaje? Vaya a"
            },
            DATA_CONFLICT: {
                HEADING: "Actualizaciones del pedido disponibles",
                SUB_HEADING: "Se ha actualizado la información del pedido. Refresca la página del pedido para verla."
            }
        }
    },
    FR: {
        FR: {
            SEARCH_PAGE: {
                HEADING: "Voir ma commande",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Numéro de commande",
                    ERROR_REQUIRED: "Le numéro de commande est requis",
                    ERROR_INVALID_FORMAT: "Format invalide"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adresse email",
                    ERROR_REQUIRED: "L'adresse email est requise",
                    ERROR_INVALID: "L'adresse email est incorrecte"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Numéro de commande oublié",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Commande non trouvée"
                },
                SEARCH_BUTTON_TEXT: "Voir la commande"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Numéro de commande oublié",
                SUBHEADING: "SVP donnez votre adresse email.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adresse email",
                    ERROR_REQUIRED: "L'adresse email est requise",
                    ERROR_INVALID: "L'adresse email est incorrecte"
                },
                SEND_BUTTON_TEXT: "Envoyez email",
                BACK_BUTTON_TEXT: "Retour",
                EMAIL_SENT: "Une confirmation de commande a été envoyée par email",
                EMAIL_NOT_FOUND: "Il n'y a pas de numéro de commande avec cette adresse email"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Commande",
                    ORDERED_ON: "Commandez le",
                    BACK_TO_SEARCH: "Retour à la recherche"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Adresse de livraison"
                    },
                    TRACKING: {
                        HEADING: "Informations de suivi",
                        TRACKING_BUTTON_MESSAGE: "Suivi de mon colis",
                        SHIPMENT_PENDING_MESSAGE: "Expédition en attente"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Récapitulatif de la commande",
                        ITEMS_SUBTOTAL_TITLE: "Sous-total des articles",
                        SHIPPING_TITLE: "Expédition et manutention",
                        DISCOUNT_TITLE: "Rabais",
                        TAXES_TITLE: "Total des taxes",
                        REFUND_TITLE: "Remboursement",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CRÉÉ",
                            ACTIVE: "CRÉÉ"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTORISÉ",
                            ACTIVE: "AUTORISATION"
                        },
                        CANCELLED: {
                            COMPLETED: "ANNULÉ",
                            ACTIVE: "ANNULÉ"
                        },
                        PROCESSED: {
                            COMPLETED: "TRAITÉ",
                            ACTIVE: "TRAITEMENT"
                        },
                        SHIPPED: {
                            COMPLETED: "ENVOYÉ",
                            ACTIVE: "EXPÉDITION"
                        },
                        DELIVERED: {
                            COMPLETED: "LIVRÉ",
                            ACTIVE: "LIVRAISON"
                        },
                        RETURNED: {
                            COMPLETED: "RETOURNÉ",
                            ACTIVE: "RETOUR"
                        },
                        REFUNDED: {
                            COMPLETED: "REMBOURSÉ",
                            ACTIVE: "REMBOURSEMENT"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Cette commande a été annulée le"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Cette commande a été remboursée"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "En attente de la réception des fonds auprès de l'institution financière"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Articles remboursés"
                    },
                    VIEW_ITEM: "Voir l'article"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "Pour toute autre demande, veuillez vous rendre sur"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Annuler la commande",
                        SUBHEADING: "Voulez-vous vraiment annuler votre commande?",
                        ERROR_FAILED: "Un problème est survenu lors de l'annulation de la commande",
                        SUCCESS_MESSAGE: "La commande a été annulée.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Annuler les articles de la commande",
                        SUBHEADING: "Veuillez sélectionner les articles que vous souhaitez annuler.",
                        ERROR_FAILED: "Un problème est survenu lors de l’annulation des articles.",
                        ERROR_CALCULATION_FAILED: "Un problème est survenu lors du calcul du remboursement.",
                        SUCCESS_MESSAGE: "Les articles ont été annulés.",
                        SUCCESS_MESSAGE_FULL_ORDER: "La commande a été annulée.",
                        SELECT_ALL_ITEMS: "Sélectionner tous les éléments",
                        CONFIRMATION: {
                            HEADING: "Annuler les articles de la commande",
                            SUBHEADING_CANCEL_ITEMS: "Êtes-vous sûr(e) de vouloir annuler le(s) cadeau(x) sélectionné(s) ?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Voulez-vous vraiment annuler votre commande?"
                        },
                        ITEMS_HEADER: "Articles",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Vous devez ajouter au moins un article"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Raison",
                    ERRORS: {
                        REASON_REQUIRED: "Vous devez sélectionner une raison"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Je me suis trompé(e) lors de l’achat",
                        NO_LONGER_NEEDED: "Je n’ai plus besoin de l’article en question",
                        BETTER_PRICE: "Je l’ai trouvé moins cher ailleurs",
                        MISTAKE: "J’ai effectué la commande par erreur"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Récapitulatif du remboursement",
                        ITEMS_SUBTOTAL_TITLE: "Sous-total des articles",
                        SHIPPING_TITLE: "Expédition et manutention",
                        DISCOUNT_TITLE: "Rabais",
                        TAXES_TITLE: "Total des taxes",
                        REFUND_TOTAL_TITLE: "Total remboursé"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Retourner la commande",
                        SUBHEADING: "Voulez-vous vraiment retourner votre commande ?",
                        ERROR_FAILED: "Une erreur s'est produite lors de la création de la demande de retour.",
                        SUCCESS_MESSAGE: "La demande de retour a été crée.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Retourner des articles",
                        SUBHEADING: "Sélectionnez les articles que vous souhaitez retourner.",
                        ERROR_FAILED: "Une erreur s'est produite lors de la création de la demande de retour.",
                        ERROR_CALCULATION_FAILED: "Un problème est survenu lors du calcul du remboursement.",
                        SUCCESS_MESSAGE: "La demande de retour a été crée.",
                        SELECT_ALL_ITEMS: "Sélectionner tous les articles",
                        CONFIRMATION: {
                            HEADING: "Retourner des articles",
                            SUBHEADING: "Voulez-vous vraiment retourner les articles sélectionnés ?"
                        },
                        ITEMS_HEADER: "Articles",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Au moins un article est requis"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Raison",
                    ERRORS: {
                        REASON_REQUIRED: "La raison est requise"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "J'ai acheté le mauvais article",
                        NO_LONGER_NEEDED: "Je n'ai plus besoin de cet article",
                        BETTER_PRICE: "J'ai trouvé un prix plus avantageux",
                        MISTAKE: "J'ai passé la commande par erreur"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Récapitulatif du remboursement",
                        ITEMS_SUBTOTAL_TITLE: "Sous-total des articles",
                        SHIPPING_TITLE: "Expédition et manutention",
                        DISCOUNT_TITLE: "Rabais",
                        TAXES_TITLE: "Total des taxes",
                        REFUND_TOTAL_TITLE: "Total remboursé"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Raison",
                    ITEMS_HEADER: "Articles",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "La raison est requise",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Générer la facture",
                    SUBHEADING: "Veuillez saisir les informations fiscales le cas échéant.",
                    SUCCESS_MESSAGE: "La facture vous a été envoyée par e-mail.",
                    ERROR_FAILED: "Échec lors de la création de la facture.",
                    ADDITIONAL_TAX_INFO_HEADER: "Informations fiscales supplémentaires"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Articles similaires",
                        SUB_HEADING: "Magasinez les articles recommandés pour vous."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Articles recommandés",
                        SUB_HEADING: "Magasinez les articles recommandés pour vous."
                    }
                },
                MENU: {
                    INVOICE: "Facture",
                    CANCEL_ITEMS: "Annuler les articles",
                    CANCEL_ORDER: "Annuler la commande",
                    RETURN_ITEMS: "Articles à retourner",
                    RETURN_ORDER: "Retourner la commande",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Demande d'assistance",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "La demande RMA a été créée"
            },
            MISC: {
                YES: "Oui",
                NO: "Non",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "PRÉ-COMMANDE",
                CANCEL: "Annuler",
                CLOSE: "Fermer",
                SUBMIT: "Soumettre",
                REFRESH: "Actualiser"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Nous avons un ennui à récupérer vos informations de commande.",
                DESCRIPTION: "Désolé! Nous n'avons pas réussi à récupérer les informations de votre commande. SVP essayez à nouveau.",
                HELP_MESSAGE: "Voyez-vous toujours ce message? Allez sur"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE INTROUVABLE",
                DESCRIPTION: "Désolé! La page recherchée n'existe pas, ou est temporairement indisponible.",
                HELP_MESSAGE: "Voyez-vous toujours ce message? Allez sur"
            },
            DATA_CONFLICT: {
                HEADING: "Mises à jour concernant la commande disponibles",
                SUB_HEADING:
                    "Les informations de la commande ont été mises à jour.Veuillez actualiser la page de la commande pour consulter les dernières informations."
            }
        }
    },
    IT: {
        IT: {
            SEARCH_PAGE: {
                HEADING: "Visualizza il mio ordine",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Numero d'ordine",
                    ERROR_REQUIRED: "Numero d'ordine richiesto",
                    ERROR_INVALID_FORMAT: "Formato non valido"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Indirizzo email",
                    ERROR_REQUIRED: "Indirizzo e-mail è richiesto",
                    ERROR_INVALID: "l'indirizzo email non è valido"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Hai dimenticato il numero dell'ordine",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Ordine non trovato"
                },
                SEARCH_BUTTON_TEXT: "Visualizza ordine"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Ho dimenticato il mio numero d'ordine",
                SUBHEADING: "Si prega di fornire il proprio indirizzo e-mail.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Indirizzo email",
                    ERROR_REQUIRED: "Indirizzo e-mail è richiesto",
                    ERROR_INVALID: "l'indirizzo email non è valido"
                },
                SEND_BUTTON_TEXT: "Invia una email",
                BACK_BUTTON_TEXT: "Torna",
                EMAIL_SENT: "È stata inviata un'e-mail di riepilogo dell'ordine",
                EMAIL_NOT_FOUND: "Nessun ordine per questo indirizzo email"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Ordine",
                    ORDERED_ON: "Ordinato il",
                    BACK_TO_SEARCH: "Torna alla ricerca"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Indirizzo di spedizione"
                    },
                    TRACKING: {
                        HEADING: "Informazioni di tracciamento",
                        TRACKING_BUTTON_MESSAGE: "Traccia la mia spedizione",
                        SHIPMENT_PENDING_MESSAGE: "In attesa di spedizione"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Riepilogo dell'ordine",
                        ITEMS_SUBTOTAL_TITLE: "Totale parziale del Prodotto(i)",
                        SHIPPING_TITLE: "Spedizione e trattamento",
                        DISCOUNT_TITLE: "Sconto",
                        TAXES_TITLE: "Imposte totali",
                        REFUND_TITLE: "Rimborso",
                        GRAND_TOTAL_TITLE: "Somma totale"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATO",
                            ACTIVE: "CREATO"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTORIZZATO",
                            ACTIVE: "AUTORIZZAZIONE"
                        },
                        CANCELLED: {
                            COMPLETED: "ANNULLATO",
                            ACTIVE: "ANNULLATO"
                        },
                        PROCESSED: {
                            COMPLETED: "ELABORATO",
                            ACTIVE: "IN LAVORAZIONE"
                        },
                        SHIPPED: {
                            COMPLETED: "SPEDITO",
                            ACTIVE: "SPEDIZIONE"
                        },
                        DELIVERED: {
                            COMPLETED: "CONSEGNATO",
                            ACTIVE: "CONSEGNA"
                        },
                        RETURNED: {
                            COMPLETED: "RESTITUITO",
                            ACTIVE: "RESO"
                        },
                        REFUNDED: {
                            COMPLETED: "RIMBORSATO",
                            ACTIVE: "RIMBORSO"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Questo ordine è stato annullato il"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Questo ordine è stato rimborsato"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "In attesa di raccolta fondi dall'istituto finanziario"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Articoli rimborsati"
                    },
                    VIEW_ITEM: "Visualizza"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "Per qualsiasi domanda, visita il sito "
                },

                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Elimina ordine",
                        SUBHEADING: "Sei sicuro di voler annullare il tuo ordine?",
                        ERROR_FAILED: "Si è verificato un problema con l'eliminazione degli ordine.",
                        SUCCESS_MESSAGE: "L’ordine è stato annullato.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Elimina articoli ordine",
                        SUBHEADING: "Seleziona articoli da eliminare.",
                        ERROR_FAILED: "Si è verificato un problema con l’eliminazione degli articoli.",
                        ERROR_CALCULATION_FAILED: "Si è verificato un problema con il calcolo del rimborso.",
                        SUCCESS_MESSAGE: "Gli articoli sono stati eliminati.",
                        SUCCESS_MESSAGE_FULL_ORDER: "L’ordine è stato annullato.",
                        SELECT_ALL_ITEMS: "Seleziona tutti gli articoli",
                        CONFIRMATION: {
                            HEADING: "Elimina articoli ordine",
                            SUBHEADING_CANCEL_ITEMS: "Vuoi davvero eliminare gli articoli selezionati?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Sei sicuro di voler annullare il tuo ordine?"
                        },
                        ITEMS_HEADER: "Articoli",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Selezionare almeno un elemento"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Motivo",
                    ERRORS: {
                        REASON_REQUIRED: "È necessario indicare un motivo"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Ho acquistato l’articolo sbagliato",
                        NO_LONGER_NEEDED: "Non mi serve più",
                        BETTER_PRICE: "È disponibile un prezzo migliore",
                        MISTAKE: "Ordine effettuato per errore"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Riepilogo rimborso",
                        ITEMS_SUBTOTAL_TITLE: "Totale parziale del Prodotto(i)",
                        SHIPPING_TITLE: "Spedizione e trattamento",
                        DISCOUNT_TITLE: "Sconto",
                        TAXES_TITLE: "Imposte totali",
                        REFUND_TOTAL_TITLE: "Totale rimborso"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Restituire l'ordine",
                        SUBHEADING: "Sei sicuro di voler restituire l'ordine?",
                        ERROR_FAILED: "Si è verificato un problema durante la creazione della richiesta di reso.",
                        SUCCESS_MESSAGE: "La richiesta di reso è stata creata.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Articoli del reso",
                        SUBHEADING: "Seleziona gli articoli che vuoi restituire.",
                        ERROR_FAILED: "Si è verificato un problema durante la creazione della richiesta di reso.",
                        ERROR_CALCULATION_FAILED: "Si è verificato un problema con il calcolo del rimborso.",
                        SUCCESS_MESSAGE: "La richiesta di reso è stata creata.",
                        SELECT_ALL_ITEMS: "Seleziona tutti gli elementi",
                        CONFIRMATION: {
                            HEADING: "Articoli del reso",
                            SUBHEADING: "Sei sicuro di voler restituire gli articoli selezionati?"
                        },
                        ITEMS_HEADER: "Articoli",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "È obbligatorio inserire almeno un articolo"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Motivo",
                    ERRORS: {
                        REASON_REQUIRED: "Il motivo è obbligatorio"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Acquistato articolo sbagliato",
                        NO_LONGER_NEEDED: "Non mi serve più",
                        BETTER_PRICE: "Trovato prezzo migliore",
                        MISTAKE: "Ordine effettuato per errore"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Riepilogo rimborso",
                        ITEMS_SUBTOTAL_TITLE: "Totale parziale del Prodotto(i)",
                        SHIPPING_TITLE: "Spedizione e trattamento",
                        DISCOUNT_TITLE: "Sconto",
                        TAXES_TITLE: "Imposte totali",
                        REFUND_TOTAL_TITLE: "Totale rimborso"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Genera fattura ordine",
                    SUBHEADING: "Immetti eventuali informazioni sulle imposte.",
                    SUCCESS_MESSAGE: "La fattura dell’ordine è stata inviata al tuo indirizzo email",
                    ERROR_FAILED: "Impossibile generare fattura ordine.",
                    ADDITIONAL_TAX_INFO_HEADER: "Informazioni sulle imposte aggiuntive"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Articoli correlati",
                        SUB_HEADING: "Acquista gli articoli consigliati."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Articoli consigliati",
                        SUB_HEADING: "Acquista gli articoli consigliati."
                    }
                },
                MENU: {
                    INVOICE: "Fattura",
                    CANCEL_ITEMS: "Elimina articoli",
                    CANCEL_ORDER: "Elimina ordine",
                    RETURN_ITEMS: "Restituisci gli articoli",
                    RETURN_ORDER: "Restituire l'ordine",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Richiedi assistenza",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "Richiesta di RMA creata"
            },
            MISC: {
                YES: "Sì",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "PRE-ORDINE",
                CANCEL: "Annulla",
                CLOSE: "Chiudi",
                SUBMIT: "Invia",
                REFRESH: "Aggiorna"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Si è verificato un problema durante il recupero delle informazioni sull'ordine",
                DESCRIPTION: "Spiacenti, impossibile ottenere informazioni sul tuo ordine. Per favore, riprova.",
                HELP_MESSAGE: "Continui a vedere questo messaggio? Vai su"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGINA NON TROVATA",
                DESCRIPTION: "Siamo spiacenti la pagina che stai cercando di trovare non esiste o è temporaneamente non disponibile.",
                HELP_MESSAGE: "Continui a vedere questo messaggio? Vai su"
            },
            DATA_CONFLICT: {
                HEADING: "Disponibili aggiornamenti sull'ordine",
                SUB_HEADING:
                    "Le informazioni sull'ordine non sono state aggiornate. Aggiorna la pagina dell'ordine per visualizzare le informazioni più recenti."
            }
        }
    },
    NZ: {
        EN: {
            SEARCH_PAGE: {
                HEADING: "View my order",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Order Number",
                    ERROR_REQUIRED: "Order number is required",
                    ERROR_INVALID_FORMAT: "Invalid format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Forgot your order number",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Order not found"
                },
                SEARCH_BUTTON_TEXT: "View"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Forgot my order number",
                SUBHEADING: "Please provide your email address.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                SEND_BUTTON_TEXT: "Send email",
                BACK_BUTTON_TEXT: "Back",
                EMAIL_SENT: "An order summary email has been sent.",
                EMAIL_NOT_FOUND: "No orders for this email address"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Order",
                    ORDERED_ON: "Ordered on",
                    BACK_TO_SEARCH: "Back to search"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Shipping Address"
                    },
                    TRACKING: {
                        HEADING: "Tracking Information",
                        TRACKING_BUTTON_MESSAGE: "Track my shipment",
                        SHIPMENT_PENDING_MESSAGE: "Shipment pending"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Order Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TITLE: "Refund",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATED",
                            ACTIVE: "CREATED"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTHORIZED",
                            ACTIVE: "AUTHORIZING"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELLED",
                            ACTIVE: "CANCELLED"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESSED",
                            ACTIVE: "PROCESSING"
                        },
                        SHIPPED: {
                            COMPLETED: "SHIPPED",
                            ACTIVE: "SHIPPING"
                        },
                        DELIVERED: {
                            COMPLETED: "DELIVERED",
                            ACTIVE: "DELIVERING"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNED",
                            ACTIVE: "RETURNING"
                        },
                        REFUNDED: {
                            COMPLETED: "REFUNDED",
                            ACTIVE: "REFUNDING"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "This order was cancelled on"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "This order was refunded"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Waiting for funds to be collected from finance institution"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Refunded Items"
                    },
                    PROTECTION: {
                        TITLE: "Protection Items"
                    },
                    EGIFTCARDS: {
                        TITLE: "eGift Cards"
                    },
                    VIEW_ITEM: "View item"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "For any other inquiries, please go to"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancel Order",
                        SUBHEADING: "Are you sure you want to cancel your order?",
                        ERROR_FAILED: "There was a problem with order cancelation.",
                        SUCCESS_MESSAGE: "Order has been cancelled.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancel Order Items",
                        SUBHEADING: "Select items you would like to cancel.",
                        ERROR_FAILED: "There was a problem with items cancelation.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Items have been cancelled.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Order has been cancelled.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Cancel Order Items",
                            SUBHEADING_CANCEL_ITEMS: "Are you sure you want to cancel selected items?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Are you sure you want to cancel your order?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Return Order",
                        SUBHEADING: "Are you sure you want to return your order?",
                        ERROR_FAILED: "There was a problem with creating order return request.",
                        SUCCESS_MESSAGE: "Return order request was created.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Return Order Items",
                        SUBHEADING: "Select items you would like to return.",
                        ERROR_FAILED: "There was a problem with creating items return request.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Return items request was created.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Return Order Items",
                            SUBHEADING: "Are you sure you want to return selected items?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generate Order Invoice",
                    SUBHEADING: "Please input any optional tax information.",
                    SUCCESS_MESSAGE: "Order invoice has been sent to your email address.",
                    ERROR_FAILED: "Failed to generate order invoice.",
                    ADDITIONAL_TAX_INFO_HEADER: "Additional Tax Info"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Related Items",
                        SUB_HEADING: "Shop for items recommended to you."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Recommended Items",
                        SUB_HEADING: "Browse for more items available for you."
                    }
                },
                MENU: {
                    INVOICE: "Invoice",
                    CANCEL_ITEMS: "Cancel Items",
                    CANCEL_ORDER: "Cancel Order",
                    RETURN_ITEMS: "Return Items",
                    RETURN_ORDER: "Return Order",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Request Assistance",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA request was created"
            },
            MISC: {
                YES: "Yes",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Preorder",
                CANCEL: "Cancel",
                CLOSE: "Close",
                SUBMIT: "Submit",
                REFRESH: "Refresh"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "There was a problem getting your order information",
                DESCRIPTION: "Sorry! We were unable to get information about your order. Please try again.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE NOT FOUND",
                DESCRIPTION: "Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            DATA_CONFLICT: {
                HEADING: "Order Updates Available",
                SUB_HEADING: "Order information has been updated. Please refresh the order page to view the latest information"
            }
        }
    },
    PT: {
        PT: {
            SEARCH_PAGE: {
                HEADING: "Ver meu pedido",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Número do pedido",
                    ERROR_REQUIRED: "O número do pedido é obrigatório",
                    ERROR_INVALID_FORMAT: "Formato Inválido"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Endereço de e-mail",
                    ERROR_REQUIRED: "É necessário um endereço de e-mail",
                    ERROR_INVALID: "Endereço de email inválido"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Esqueceu o número do seu pedido",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Pedido não encontrado"
                },
                SEARCH_BUTTON_TEXT: "Exibir pedido"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Esqueci o número do meu pedido",
                SUBHEADING: "Por favor forneça seu endereço de e-mail.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Endereço de e-mail",
                    ERROR_REQUIRED: "É necessário um endereço de e-mail",
                    ERROR_INVALID: "Endereço de email inválido"
                },
                SEND_BUTTON_TEXT: "Enviar email",
                BACK_BUTTON_TEXT: "Voltar",
                EMAIL_SENT: "Umresumo do pedido foi enviado por email",
                EMAIL_NOT_FOUND: "Nenhum pedido para este endereço de e-mail"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Pedido",
                    ORDERED_ON: "Pedido em",
                    BACK_TO_SEARCH: "Voltar à pesquisa"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Endereço de envio"
                    },
                    TRACKING: {
                        HEADING: "Informações de seguimento",
                        TRACKING_BUTTON_MESSAGE: "Rastrear minha remessa",
                        SHIPMENT_PENDING_MESSAGE: "Envio pendente"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Resumo do pedido",
                        ITEMS_SUBTOTAL_TITLE: "Item (s) Subtotal",
                        SHIPPING_TITLE: "Envio e  Tratamento",
                        DISCOUNT_TITLE: "Desconto",
                        TAXES_TITLE: "Total de impostos",
                        REFUND_TITLE: "Reembolso",
                        GRAND_TOTAL_TITLE: "Total geral"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CRIADO",
                            ACTIVE: "CRIADO"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTORIZADO",
                            ACTIVE: "A AUTORIZAR"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELADO",
                            ACTIVE: "CANCELADO"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESSADO",
                            ACTIVE: "A PROCESSAR"
                        },
                        SHIPPED: {
                            COMPLETED: "ENVIADO",
                            ACTIVE: "A ENVIAR"
                        },
                        DELIVERED: {
                            COMPLETED: "ENTREGUE",
                            ACTIVE: "A ENTREGAR"
                        },
                        RETURNED: {
                            COMPLETED: "DEVOLVIDO",
                            ACTIVE: "A DEVOLVER"
                        },
                        REFUNDED: {
                            COMPLETED: "REEMBOLSADO",
                            ACTIVE: "A REEMBOLSAR"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Este pedido foi cancelado em"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Este pedido foi reembolsado"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Aguardando a coleta de fundos pela instituição financeira"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Itens Reembolsados"
                    },
                    VIEW_ITEM: "Ver item"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "Para quaisquer outros pedidos de informação, vá a"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancelar pedido",
                        SUBHEADING: "Você tem certeza que quer cancelar seu pedido?",
                        ERROR_FAILED: "Ocorreu um problema com o cancelamento do pedido.",
                        SUCCESS_MESSAGE: "A encomenda foi cancelada.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancelar itens da encomenda",
                        SUBHEADING: "Selecione os itens que pretende cancelar.",
                        ERROR_FAILED: "Ocorreu um problema com o cancelamento dos itens.",
                        ERROR_CALCULATION_FAILED: "Ocorreu um problema com o cálculo do reembolso.",
                        SUCCESS_MESSAGE: "Os itens foram cancelados.",
                        SUCCESS_MESSAGE_FULL_ORDER: "A encomenda foi cancelada.",
                        SELECT_ALL_ITEMS: "Selecionar todos os itens",
                        CONFIRMATION: {
                            HEADING: "Cancelar itens da encomenda",
                            SUBHEADING_CANCEL_ITEMS: "Tem a certeza de que deseja cancelar os itens selecionados?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Você tem certeza que quer cancelar seu pedido?"
                        },
                        ITEMS_HEADER: "Itens",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "É necessário, pelo menos, um item"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Motivo",
                    ERRORS: {
                        REASON_REQUIRED: "É necessário um motivo"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Item errado comprado",
                        NO_LONGER_NEEDED: "Já não é necessário",
                        BETTER_PRICE: "Melhor preço disponível",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Resumo de reembolso",
                        ITEMS_SUBTOTAL_TITLE: "Item (s) Subtotal",
                        SHIPPING_TITLE: "Envio e  Tratamento",
                        DISCOUNT_TITLE: "Desconto",
                        TAXES_TITLE: "Total de impostos",
                        REFUND_TOTAL_TITLE: "Total de reembolso"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Devolver encomenda",
                        SUBHEADING: "Tem a certeza de que quer devolver a sua encomenda?",
                        ERROR_FAILED: "Ocorreu um problema ao criar um pedido de devolução.",
                        SUCCESS_MESSAGE: "O pedido de devolução foi criado.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Devolver itens da encomenda",
                        SUBHEADING: "Selecione os itens que quer devolver.",
                        ERROR_FAILED: "Ocorreu um problema ao criar um pedido de devolução.",
                        ERROR_CALCULATION_FAILED: "Ocorreu um erro ao calcular o reembolso.",
                        SUCCESS_MESSAGE: "O pedido de devolução foi criado.",
                        SELECT_ALL_ITEMS: "Selecionar todos os itens",
                        CONFIRMATION: {
                            HEADING: "Devolver itens da encomenda",
                            SUBHEADING: "Tem a certeza de que quer devolver os itens selecionados?"
                        },
                        ITEMS_HEADER: "Itens",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "É necessário pelo menos um item"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Motivo",
                    ERRORS: {
                        REASON_REQUIRED: "É necessáiro o motivo"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Adquirido item errado",
                        NO_LONGER_NEEDED: "Já não necessito",
                        BETTER_PRICE: "Melhor preço disponível",
                        MISTAKE: "Encomenda efetuada por engano"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Resumo de reembolso",
                        ITEMS_SUBTOTAL_TITLE: "Item (s) Subtotal",
                        SHIPPING_TITLE: "Envio e  Tratamento",
                        DISCOUNT_TITLE: "Desconto",
                        TAXES_TITLE: "Total de impostos",
                        REFUND_TOTAL_TITLE: "Total de reembolso"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Gerar fatura da encomenda",
                    SUBHEADING: "Introduza eventuais informações fiscais opcionais.",
                    SUCCESS_MESSAGE: "A fatura da encomenda foi enviada para o seu endereço de e-mail.",
                    ERROR_FAILED: "Não foi possível gerar a fatura da encomenda .",
                    ADDITIONAL_TAX_INFO_HEADER: "Informações fiscais adicionais"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Itens relacionados",
                        SUB_HEADING: "Compre itens recomendados para você."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Itens recomendados",
                        SUB_HEADING: "Compre itens recomendados para você."
                    }
                },
                MENU: {
                    INVOICE: "Fatura",
                    CANCEL_ITEMS: "Cancelar itens",
                    CANCEL_ORDER: "Cancelar pedido",
                    RETURN_ITEMS: "Devolver itens",
                    RETURN_ORDER: "Devolver encomenda",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Pedir assistência",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "ADM foi criada"
            },
            MISC: {
                YES: "Sim",
                NO: "Não",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "PEDIDO ANTECIPADO",
                CANCEL: "Cancelar",
                CLOSE: "Fechar",
                SUBMIT: "Submeter",
                REFRESH: "Atualizar"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Ocorreu um problema ao obter as informações do pedido",
                DESCRIPTION: "Desculpa! Não foi possível obter informações sobre seu pedido. Por favor, tente novamente.",
                HELP_MESSAGE: "Continua vendo esta mensagem? Acesse"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PÁGINA NÃO ENCONTRADA",
                DESCRIPTION: "Desculpa! A página que você está tentando encontrar não existe ou está temporariamente indisponível.",
                HELP_MESSAGE: "Continua vendo esta mensagem? Acesse"
            },
            DATA_CONFLICT: {
                HEADING: "Atualizações da encomenda disponíveis",
                SUB_HEADING: "As informações da encomenda foram atualizadas.Atualize a página da encomenda e visualize a informação mais recente."
            }
        }
    },
    SG: {
        EN: {
            SEARCH_PAGE: {
                HEADING: "View my order",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Order Number",
                    ERROR_REQUIRED: "Order number is required",
                    ERROR_INVALID_FORMAT: "Invalid format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Forgot your order number",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Order not found"
                },
                SEARCH_BUTTON_TEXT: "View"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Forgot my order number",
                SUBHEADING: "Please provide your email address.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                SEND_BUTTON_TEXT: "Send email",
                BACK_BUTTON_TEXT: "Back",
                EMAIL_SENT: "An order summary email has been sent.",
                EMAIL_NOT_FOUND: "No orders for this email address"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Order",
                    ORDERED_ON: "Ordered on",
                    BACK_TO_SEARCH: "Back to search"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Shipping Address"
                    },
                    TRACKING: {
                        HEADING: "Tracking Information",
                        TRACKING_BUTTON_MESSAGE: "Track my shipment",
                        SHIPMENT_PENDING_MESSAGE: "Shipment pending"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Order Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TITLE: "Refund",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATED",
                            ACTIVE: "CREATED"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTHORIZED",
                            ACTIVE: "AUTHORIZING"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELLED",
                            ACTIVE: "CANCELLED"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESSED",
                            ACTIVE: "PROCESSING"
                        },
                        SHIPPED: {
                            COMPLETED: "SHIPPED",
                            ACTIVE: "SHIPPING"
                        },
                        DELIVERED: {
                            COMPLETED: "DELIVERED",
                            ACTIVE: "DELIVERING"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNED",
                            ACTIVE: "RETURNING"
                        },
                        REFUNDED: {
                            COMPLETED: "REFUNDED",
                            ACTIVE: "REFUNDING"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "This order was cancelled on"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "This order was refunded"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Waiting for funds to be collected from finance institution"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Refunded Items"
                    },
                    PROTECTION: {
                        TITLE: "Protection Items"
                    },
                    EGIFTCARDS: {
                        TITLE: "eGift Cards"
                    },
                    VIEW_ITEM: "View item"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "For any other inquiries, please go to"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancel Order",
                        SUBHEADING: "Are you sure you want to cancel your order?",
                        ERROR_FAILED: "There was a problem with order cancelation.",
                        SUCCESS_MESSAGE: "Order has been cancelled.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancel Order Items",
                        SUBHEADING: "Select items you would like to cancel.",
                        ERROR_FAILED: "There was a problem with items cancelation.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Items have been cancelled.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Order has been cancelled.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Cancel Order Items",
                            SUBHEADING_CANCEL_ITEMS: "Are you sure you want to cancel selected items?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Are you sure you want to cancel your order?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Return Order",
                        SUBHEADING: "Are you sure you want to return your order?",
                        ERROR_FAILED: "There was a problem with creating order return request.",
                        SUCCESS_MESSAGE: "Return order request was created.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Return Order Items",
                        SUBHEADING: "Select items you would like to return.",
                        ERROR_FAILED: "There was a problem with creating items return request.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Return items request was created.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Return Order Items",
                            SUBHEADING: "Are you sure you want to return selected items?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generate Order Invoice",
                    SUBHEADING: "Please input any optional tax information.",
                    SUCCESS_MESSAGE: "Order invoice has been sent to your email address.",
                    ERROR_FAILED: "Failed to generate order invoice.",
                    ADDITIONAL_TAX_INFO_HEADER: "Additional Tax Info"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Related Items",
                        SUB_HEADING: "Shop for items recommended to you."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Recommended Items",
                        SUB_HEADING: "Browse for more items available for you."
                    }
                },
                MENU: {
                    INVOICE: "Invoice",
                    CANCEL_ITEMS: "Cancel Items",
                    CANCEL_ORDER: "Cancel Order",
                    RETURN_ITEMS: "Return Items",
                    RETURN_ORDER: "Return Order",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Request Assistance",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA request was created"
            },
            MISC: {
                YES: "Yes",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Preorder",
                CANCEL: "Cancel",
                CLOSE: "Close",
                SUBMIT: "Submit",
                REFRESH: "Refresh"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "There was a problem getting your order information",
                DESCRIPTION: "Sorry! We were unable to get information about your order. Please try again.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE NOT FOUND",
                DESCRIPTION: "Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            DATA_CONFLICT: {
                HEADING: "Order Updates Available",
                SUB_HEADING: "Order information has been updated. Please refresh the order page to view the latest information"
            }
        }
    },
    UK: {
        EN: {
            SEARCH_PAGE: {
                HEADING: "View my order",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Order Number",
                    ERROR_REQUIRED: "Order number is required",
                    ERROR_INVALID_FORMAT: "Invalid format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Forgot your order number",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Order not found"
                },
                SEARCH_BUTTON_TEXT: "View"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Forgot my order number",
                SUBHEADING: "Please provide your email address.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                SEND_BUTTON_TEXT: "Send email",
                BACK_BUTTON_TEXT: "Back",
                EMAIL_SENT: "An order summary email has been sent.",
                EMAIL_NOT_FOUND: "No orders for this email address"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Order",
                    ORDERED_ON: "Ordered on",
                    BACK_TO_SEARCH: "Back to search"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Shipping Address"
                    },
                    TRACKING: {
                        HEADING: "Tracking Information",
                        TRACKING_BUTTON_MESSAGE: "Track my shipment",
                        SHIPMENT_PENDING_MESSAGE: "Shipment pending"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Order Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TITLE: "Refund",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATED",
                            ACTIVE: "CREATED"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTHORIZED",
                            ACTIVE: "AUTHORIZING"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELLED",
                            ACTIVE: "CANCELLED"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESSED",
                            ACTIVE: "PROCESSING"
                        },
                        SHIPPED: {
                            COMPLETED: "SHIPPED",
                            ACTIVE: "SHIPPING"
                        },
                        DELIVERED: {
                            COMPLETED: "DELIVERED",
                            ACTIVE: "DELIVERING"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNED",
                            ACTIVE: "RETURNING"
                        },
                        REFUNDED: {
                            COMPLETED: "REFUNDED",
                            ACTIVE: "REFUNDING"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "This order was cancelled on"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "This order was refunded"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Waiting for funds to be collected from finance institution"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Refunded Items"
                    },
                    PROTECTION: {
                        TITLE: "Protection Items"
                    },
                    EGIFTCARDS: {
                        TITLE: "eGift Cards"
                    },
                    VIEW_ITEM: "View item"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "For any other inquiries, please go to"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancel Order",
                        SUBHEADING: "Are you sure you want to cancel your order?",
                        ERROR_FAILED: "There was a problem with order cancelation.",
                        SUCCESS_MESSAGE: "Order has been cancelled.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancel Order Items",
                        SUBHEADING: "Select items you would like to cancel.",
                        ERROR_FAILED: "There was a problem with items cancelation.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Items have been cancelled.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Order has been cancelled.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Cancel Order Items",
                            SUBHEADING_CANCEL_ITEMS: "Are you sure you want to cancel selected items?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Are you sure you want to cancel your order?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Return Order",
                        SUBHEADING: "Are you sure you want to return your order?",
                        ERROR_FAILED: "There was a problem with creating order return request.",
                        SUCCESS_MESSAGE: "Return order request was created.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Return Order Items",
                        SUBHEADING: "Select items you would like to return.",
                        ERROR_FAILED: "There was a problem with creating items return request.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Return items request was created.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Return Order Items",
                            SUBHEADING: "Are you sure you want to return selected items?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generate Order Invoice",
                    SUBHEADING: "Please input any optional tax information.",
                    SUCCESS_MESSAGE: "Order invoice has been sent to your email address.",
                    ERROR_FAILED: "Failed to generate order invoice.",
                    ADDITIONAL_TAX_INFO_HEADER: "Additional Tax Info"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Related Items",
                        SUB_HEADING: "Shop for items recommended to you."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Recommended Items",
                        SUB_HEADING: "Browse for more items available for you."
                    }
                },
                MENU: {
                    INVOICE: "Invoice",
                    CANCEL_ITEMS: "Cancel Items",
                    CANCEL_ORDER: "Cancel Order",
                    RETURN_ITEMS: "Return Items",
                    RETURN_ORDER: "Return Order",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Request Assistance",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA request was created"
            },
            MISC: {
                YES: "Yes",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Preorder",
                CANCEL: "Cancel",
                CLOSE: "Close",
                SUBMIT: "Submit",
                REFRESH: "Refresh"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "There was a problem getting your order information",
                DESCRIPTION: "Sorry! We were unable to get information about your order. Please try again.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE NOT FOUND",
                DESCRIPTION: "Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            DATA_CONFLICT: {
                HEADING: "Order Updates Available",
                SUB_HEADING: "Order information has been updated. Please refresh the order page to view the latest information"
            }
        }
    },
    US: {
        EN: {
            SEARCH_PAGE: {
                HEADING: "View my order",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Order Number",
                    ERROR_REQUIRED: "Order number is required",
                    ERROR_INVALID_FORMAT: "Invalid format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Forgot your order number",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Order not found"
                },
                SEARCH_BUTTON_TEXT: "View"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Forgot my order number",
                SUBHEADING: "Please provide your email address.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                SEND_BUTTON_TEXT: "Send email",
                BACK_BUTTON_TEXT: "Back",
                EMAIL_SENT: "An order summary email has been sent.",
                EMAIL_NOT_FOUND: "No orders for this email address"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Order",
                    ORDERED_ON: "Ordered on",
                    BACK_TO_SEARCH: "Back to search"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Shipping Address"
                    },
                    TRACKING: {
                        HEADING: "Tracking Information",
                        TRACKING_BUTTON_MESSAGE: "Track my shipment",
                        SHIPMENT_PENDING_MESSAGE: "Shipment pending"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Order Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TITLE: "Refund",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATED",
                            ACTIVE: "CREATED"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTHORIZED",
                            ACTIVE: "AUTHORIZING"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELLED",
                            ACTIVE: "CANCELLED"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESSED",
                            ACTIVE: "PROCESSING"
                        },
                        SHIPPED: {
                            COMPLETED: "SHIPPED",
                            ACTIVE: "SHIPPING"
                        },
                        DELIVERED: {
                            COMPLETED: "DELIVERED",
                            ACTIVE: "DELIVERING"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNED",
                            ACTIVE: "RETURNING"
                        },
                        REFUNDED: {
                            COMPLETED: "REFUNDED",
                            ACTIVE: "REFUNDING"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "This order was cancelled on"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "This order was refunded"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Waiting for funds to be collected from finance institution"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Refunded Items"
                    },
                    PROTECTION: {
                        TITLE: "Protection Items"
                    },
                    EGIFTCARDS: {
                        TITLE: "eGift Cards"
                    },
                    VIEW_ITEM: "View item"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "For any other inquiries, please go to"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancel Order",
                        SUBHEADING: "Are you sure you want to cancel your order?",
                        ERROR_FAILED: "There was a problem with order cancelation.",
                        SUCCESS_MESSAGE: "Order has been cancelled.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancel Order Items",
                        SUBHEADING: "Select items you would like to cancel.",
                        ERROR_FAILED: "There was a problem with items cancelation.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Items have been cancelled.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Order has been cancelled.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Cancel Order Items",
                            SUBHEADING_CANCEL_ITEMS: "Are you sure you want to cancel selected items?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Are you sure you want to cancel your order?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Return Order",
                        SUBHEADING: "Are you sure you want to return your order?",
                        ERROR_FAILED: "There was a problem with creating order return request.",
                        SUCCESS_MESSAGE: "Return order request was created.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Return Order Items",
                        SUBHEADING: "Select items you would like to return.",
                        ERROR_FAILED: "There was a problem with creating items return request.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Return items request was created.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Return Order Items",
                            SUBHEADING: "Are you sure you want to return selected items?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generate Order Invoice",
                    SUBHEADING: "Please input any optional tax information.",
                    SUCCESS_MESSAGE: "Order invoice has been sent to your email address.",
                    ERROR_FAILED: "Failed to generate order invoice.",
                    ADDITIONAL_TAX_INFO_HEADER: "Additional Tax Info"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Related Items",
                        SUB_HEADING: "Shop for items recommended to you."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Recommended Items",
                        SUB_HEADING: "Browse for more items available for you."
                    }
                },
                MENU: {
                    INVOICE: "Invoice",
                    CANCEL_ITEMS: "Cancel Items",
                    CANCEL_ORDER: "Cancel Order",
                    RETURN_ITEMS: "Return Items",
                    RETURN_ORDER: "Return Order",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Request Assistance",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA request was created"
            },
            MISC: {
                YES: "Yes",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Preorder",
                CANCEL: "Cancel",
                CLOSE: "Close",
                SUBMIT: "Submit",
                REFRESH: "Refresh"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "There was a problem getting your order information",
                DESCRIPTION: "Sorry! We were unable to get information about your order. Please try again.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE NOT FOUND",
                DESCRIPTION: "Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            DATA_CONFLICT: {
                HEADING: "Order Updates Available",
                SUB_HEADING: "Order information has been updated. Please refresh the order page to view the latest information"
            }
        }
    },
    BE: {
        NL: {
            SEARCH_PAGE: {
                HEADING: "Mijn bestelling bekijken",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Bestelnummer",
                    ERROR_REQUIRED: "Bestelnummer is vereist",
                    ERROR_INVALID_FORMAT: "Bestelnummer is ongeldig"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "E-mailadres",
                    ERROR_REQUIRED: "E-mailadres is vereist",
                    ERROR_INVALID: "E-mailadres is ongeldig"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Uw bestelnummer vergeten",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Bestelling niet gevonden"
                },
                SEARCH_BUTTON_TEXT: "Bestelling bekijken"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Mijn bestelnummer vergeten",
                SUBHEADING: "Voer uw e-mailadres in.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "E-mailadres",
                    ERROR_REQUIRED: "E-mailadres is vereist",
                    ERROR_INVALID: "E-mailadres is ongeldig"
                },
                SEND_BUTTON_TEXT: "E-mail verzenden",
                BACK_BUTTON_TEXT: "Terug",
                EMAIL_SENT: "Er is een e-mail verzonden met een overzicht van de bestelling.",
                EMAIL_NOT_FOUND: "Geen bestellingen voor dit e-mailadres"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Bestelling",
                    ORDERED_ON: "Besteld op",
                    BACK_TO_SEARCH: "Terug naar zoeken"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Verzendadres"
                    },
                    TRACKING: {
                        HEADING: "Volginformatie",
                        TRACKING_BUTTON_MESSAGE: "Mijn zending volgen",
                        SHIPMENT_PENDING_MESSAGE: "Verzending in behandeling"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Samenvatting van de bestelling",
                        ITEMS_SUBTOTAL_TITLE: "Subtotaal artikel(en)",
                        SHIPPING_TITLE: "Verzending en Behandeling",
                        DISCOUNT_TITLE: "Korting",
                        TAXES_TITLE: "Totaal belastingen",
                        REFUND_TITLE: "Terugbetaling",
                        GRAND_TOTAL_TITLE: "Eindtotaal"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "AANGEMAAKT",
                            ACTIVE: "AANGEMAAKT"
                        },
                        AUTHORIZED: {
                            COMPLETED: "GEAUTORISEERD",
                            ACTIVE: "MACHTIGEN"
                        },
                        CANCELLED: {
                            COMPLETED: "GEANNULEERD",
                            ACTIVE: "GEANNULEERD"
                        },
                        PROCESSED: {
                            COMPLETED: "VERWERKT",
                            ACTIVE: "VERWERKEN"
                        },
                        SHIPPED: {
                            COMPLETED: "VERZONDEN",
                            ACTIVE: "VERZENDEN"
                        },
                        DELIVERED: {
                            COMPLETED: "GELEVERD",
                            ACTIVE: "BEZORGEN"
                        },
                        RETURNED: {
                            COMPLETED: "TERUGGEZONDEN",
                            ACTIVE: "RETOURNEREN"
                        },
                        REFUNDED: {
                            COMPLETED: "TERUGBETAALD",
                            ACTIVE: "TERUGBETALEN"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Deze bestelling is geannuleerd op"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Deze bestelling is terugbetaald"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Wachtend op inning van fondsen bij financiële instelling"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Terugbetaalde artikelen"
                    },
                    VIEW_ITEM: "Artikel bekijken"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "Ga voor andere vragen naar"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Annuleer bestelling",
                        SUBHEADING: "Weet u zeker dat u uw bestelling wilt annuleren?",
                        ERROR_FAILED: "Er was een probleem met het annuleren van de bestelling.",
                        SUCCESS_MESSAGE: "Bestelling is geannuleerd.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Annuleren bestelitems",
                        SUBHEADING: "Selecteer items die u wilt annuleren.",
                        ERROR_FAILED: "Er was een probleem met het annuleren van artikelen.",
                        ERROR_CALCULATION_FAILED: "Er was een probleem met de berekening van de terugbetaling.",
                        SUCCESS_MESSAGE: "Items zijn geannuleerd.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Bestelling is geannuleerd.",
                        SELECT_ALL_ITEMS: "Selecteer alle items",
                        CONFIRMATION: {
                            HEADING: "Annuleren bestelitems",
                            SUBHEADING_CANCEL_ITEMS: "Weet u zeker dat u de geselecteerde items wilt annuleren?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Weet u zeker dat u uw bestelling wilt annuleren?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Minimaal één item is vereist"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reden",
                    ERRORS: {
                        REASON_REQUIRED: "Reden is vereist"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Verkeerde item besteld",
                        NO_LONGER_NEEDED: "Niet langer nodig",
                        BETTER_PRICE: "Betere prijs beschikbaar",
                        MISTAKE: "Bestelling per ongeluk geplaatst"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Samenvatting terugbetaling",
                        ITEMS_SUBTOTAL_TITLE: "Subtotaal artikel(en)",
                        SHIPPING_TITLE: "Verzending en Behandeling",
                        DISCOUNT_TITLE: "Korting",
                        TAXES_TITLE: "Totaal belastingen",
                        REFUND_TOTAL_TITLE: "Totaal terugbetaling"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Bestelling retourneren",
                        SUBHEADING: "Weet je zeker dat je je bestelling wilt retourneren?",
                        ERROR_FAILED: "Er is een probleem opgetreden bij het aanmaken van een retourverzoek.",
                        SUCCESS_MESSAGE: "Retourverzoek is aangemaakt.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Bestelde artikelen retourneren",
                        SUBHEADING: "Selecteer de artikelen die je wilt retourneren.",
                        ERROR_FAILED: "Er is een probleem opgetreden bij het aanmaken van een retourverzoek.",
                        ERROR_CALCULATION_FAILED: "Er is een probleem opgetreden bij het berekenen van de terugbetaling.",
                        SUCCESS_MESSAGE: "Retourverzoek is aangemaakt.",
                        SELECT_ALL_ITEMS: "Selecteer alle artikelen",
                        CONFIRMATION: {
                            HEADING: "Bestelde artikelen retourneren",
                            SUBHEADING: "Weet je zeker dat je de geselecteerde artikelen wilt retourneren?"
                        },
                        ITEMS_HEADER: "Artikelen",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Er is minimaal een artikel vereist"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reden",
                    ERRORS: {
                        REASON_REQUIRED: "Reden is vereist"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Verkeerde artikel gekocht",
                        NO_LONGER_NEEDED: "Niet langer nodig",
                        BETTER_PRICE: "Betere prijs beschikbaar",
                        MISTAKE: "Bestelling per ongeluk geplaatst"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Overzicht terugbetaling",
                        ITEMS_SUBTOTAL_TITLE: "Subtotaal artikel(en)",
                        SHIPPING_TITLE: "Verzending en behandeling",
                        DISCOUNT_TITLE: "Korting",
                        TAXES_TITLE: "Totaal belastingen",
                        REFUND_TOTAL_TITLE: "Totale terugbetaling"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Bestelfactuur aanmaken",
                    SUBHEADING: "Voeg eventuele belastinginformatie in.",
                    SUCCESS_MESSAGE: "Bestelfactuur is verzonden naar uw e-mailadres.",
                    ERROR_FAILED: "Kon bestelfactuur niet genereren.",
                    ADDITIONAL_TAX_INFO_HEADER: "Aanvullende belastinginformatie"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Gerelateerde artikelen",
                        SUB_HEADING: "Koop voor u aanbevolen artikelen."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Aanbevolen artikelen",
                        SUB_HEADING: "Bekijk andere voor u beschikbare artikelen."
                    }
                },
                MENU: {
                    INVOICE: "Factuur",
                    CANCEL_ITEMS: "Annuleren bestelitems",
                    CANCEL_ORDER: "Annuleer bestelling",
                    RETURN_ITEMS: "Artikelen retourneren",
                    RETURN_ORDER: "Bestelling retourneren",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Hulp vragen",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA-verzoek is aangemaakt"
            },
            MISC: {
                YES: "Ja",
                NO: "Nee",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "VOORUITBESTELLEN",
                CANCEL: "Annuleren",
                CLOSE: "Sluiten",
                SUBMIT: "Verzenden",
                REFRESH: "Verversen"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Er is een probleem opgetreden bij het ophalen van uw bestelgegevens",
                DESCRIPTION: "Sorry! We konden geen informatie over uw bestelling ophalen. Probeer het opnieuw.",
                HELP_MESSAGE: "Blijf u dit bericht zien? Ga naar"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGINA NIET GEVONDEN",
                DESCRIPTION: "Sorry! De pagina die u probeert te vinden bestaat niet of is tijdelijk niet beschikbaar.",
                HELP_MESSAGE: "Blijf u dit bericht zien? Ga naar"
            },
            DATA_CONFLICT: {
                HEADING: "Updates beschikbaar voor bestelling",
                SUB_HEADING: "Bestelinformatie is bijgewerkt.Vernieuw de bestelpagina om de nieuwste informatie te zien."
            }
        },
        FR: {
            SEARCH_PAGE: {
                HEADING: "Afficher ma commande",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Numéro de commande",
                    ERROR_REQUIRED: "Veuillez saisir un numéro de commande",
                    ERROR_INVALID_FORMAT: "Numéro de commande n'est pas valide"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adresse e-mail",
                    ERROR_REQUIRED: "Veuillez saisir une adresse e-mail",
                    ERROR_INVALID: "L’adresse e-mail saisie n’est pas valide"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Vous avez oublié votre numéro de commande",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Commande introuvable"
                },
                SEARCH_BUTTON_TEXT: "Afficher la commande"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "J’ai oublié mon numéro de commande",
                SUBHEADING: "Veuillez fournir une adresse e-mail.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adresse e-mail",
                    ERROR_REQUIRED: "Veuillez saisir une adresse e-mail",
                    ERROR_INVALID: "L’adresse e-mail saisie n’est pas valide"
                },
                SEND_BUTTON_TEXT: "Envoyer un e-mail",
                BACK_BUTTON_TEXT: "Retour",
                EMAIL_SENT: "Un résumé de votre commande vous a été envoyé par e-mail.",
                EMAIL_NOT_FOUND: "Aucune commande n’est associée à cette adresse e-mail"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Commande",
                    ORDERED_ON: "Commande passée le",
                    BACK_TO_SEARCH: "Retour à l’outil de recherche"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Adresse de livraison"
                    },
                    TRACKING: {
                        HEADING: "Informations de suivi",
                        TRACKING_BUTTON_MESSAGE: "Suivre mon expédition",
                        SHIPMENT_PENDING_MESSAGE: "Expédition en attente"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Résumé de la commande",
                        ITEMS_SUBTOTAL_TITLE: "Sous-total article(s)",
                        SHIPPING_TITLE: "Expédition et traitement",
                        DISCOUNT_TITLE: "Réduction",
                        TAXES_TITLE: "Total des taxes",
                        REFUND_TITLE: "Remboursement",
                        GRAND_TOTAL_TITLE: "Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CRÉÉ",
                            ACTIVE: "CRÉÉ"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTORISÉ",
                            ACTIVE: "AUTORISATION"
                        },
                        CANCELLED: {
                            COMPLETED: "ANNULÉ",
                            ACTIVE: "ANNULÉ"
                        },
                        PROCESSED: {
                            COMPLETED: "TRAITÉ",
                            ACTIVE: "TRAITEMENT"
                        },
                        SHIPPED: {
                            COMPLETED: "EXPÉDIÉ",
                            ACTIVE: "EXPÉDITION"
                        },
                        DELIVERED: {
                            COMPLETED: "LIVRÉ",
                            ACTIVE: "LIVRAISON"
                        },
                        RETURNED: {
                            COMPLETED: "RETOURNÉ",
                            ACTIVE: "RETOUR"
                        },
                        REFUNDED: {
                            COMPLETED: "REMBOURSÉ",
                            ACTIVE: "REMBOURSEMENT"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Cette commande a été annulée le"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Cette commande a été remboursée"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "En attente des fonds nécessaires auprès de l’institution financière"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Articles remboursés"
                    },
                    VIEW_ITEM: "Afficher l’article"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "Pour toute autre demande, veuillez vous rendre sur"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Annuler la commande",
                        SUBHEADING: "Voulez-vous vraiment annuler votre commande?",
                        ERROR_FAILED: "Un problème est survenu lors de l'annulation de la commande",
                        SUCCESS_MESSAGE: "La commande a été annulée.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Annuler les articles de la commande",
                        SUBHEADING: "Veuillez sélectionner les articles que vous souhaitez annuler.",
                        ERROR_FAILED: "Un problème est survenu lors de l’annulation des articles.",
                        ERROR_CALCULATION_FAILED: "Un problème est survenu lors du calcul du remboursement.",
                        SUCCESS_MESSAGE: "Les articles ont été annulés.",
                        SUCCESS_MESSAGE_FULL_ORDER: "La commande a été annulée.",
                        SELECT_ALL_ITEMS: "Sélectionner tous les éléments",
                        CONFIRMATION: {
                            HEADING: "Annuler les articles de la commande",
                            SUBHEADING_CANCEL_ITEMS: "Êtes-vous sûr(e) de vouloir annuler le(s) cadeau(x) sélectionné(s) ?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Voulez-vous vraiment annuler votre commande?"
                        },
                        ITEMS_HEADER: "Articles",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Vous devez ajouter au moins un article"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Raison",
                    ERRORS: {
                        REASON_REQUIRED: "Vous devez sélectionner une raison"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Je me suis trompé(e) lors de l’achat",
                        NO_LONGER_NEEDED: "Je n’ai plus besoin de l’article en question",
                        BETTER_PRICE: "Je l’ai trouvé moins cher ailleurs",
                        MISTAKE: "J’ai effectué la commande par erreur"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Récapitulatif du remboursement",
                        ITEMS_SUBTOTAL_TITLE: "Sous-total des articles",
                        SHIPPING_TITLE: "Expédition et manutention",
                        DISCOUNT_TITLE: "Rabais",
                        TAXES_TITLE: "Total des taxes",
                        REFUND_TOTAL_TITLE: "Total remboursé"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Renvoyer la commande",
                        SUBHEADING: "Voulez-vous vraiment renvoyer votre commande ?",
                        ERROR_FAILED: "Un problème est survenu lors de la création de la demande de retour.",
                        SUCCESS_MESSAGE: "La demande de retour a été générée.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Renvoyer des articles de la commande",
                        SUBHEADING: "Sélectionnez les articles que vous souhaitez retourner.",
                        ERROR_FAILED: "Un problème est survenu lors de la création de la demande de retour.",
                        ERROR_CALCULATION_FAILED: "Un problème est survenu lors du calcul du remboursement.",
                        SUCCESS_MESSAGE: "La demande de retour a été générée.",
                        SELECT_ALL_ITEMS: "Sélectionner tous les articles",
                        CONFIRMATION: {
                            HEADING: "Renvoyer des articles de la commande",
                            SUBHEADING: "Voulez-vous vraiment renvoyer les articles sélectionnés ?"
                        },
                        ITEMS_HEADER: "Articles",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Sélectionner au moins un article"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Motif",
                    ERRORS: {
                        REASON_REQUIRED: "Le motif du retour est requis"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "J'ai acheté le mauvais article",
                        NO_LONGER_NEEDED: "Je n'en ai plus besoin",
                        BETTER_PRICE: "J'ai trouvé un meilleur prix",
                        MISTAKE: "La commande a été passée par erreur"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Récapitulatif du remboursement",
                        ITEMS_SUBTOTAL_TITLE: "Sous-total des articles",
                        SHIPPING_TITLE: "Expédition et manutention",
                        DISCOUNT_TITLE: "Rabais",
                        TAXES_TITLE: "Total des taxes",
                        REFUND_TOTAL_TITLE: "Total remboursé"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Générer la facture",
                    SUBHEADING: "Veuillez saisir les informations fiscales le cas échéant.",
                    SUCCESS_MESSAGE: "La facture vous a été envoyée par e-mail.",
                    ERROR_FAILED: "Échec lors de la création de la facture.",
                    ADDITIONAL_TAX_INFO_HEADER: "Informations fiscales supplémentaires"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Articles associés",
                        SUB_HEADING: "Découvrez les articles recommandés pour vous."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Articles recommandés",
                        SUB_HEADING: "Découvrir plus d’articles disponibles pour vous."
                    }
                },
                MENU: {
                    INVOICE: "Facture",
                    CANCEL_ITEMS: "Annuler les articles",
                    CANCEL_ORDER: "Annuler la commande",
                    RETURN_ITEMS: "Renvoyer les articles",
                    RETURN_ORDER: "Renvoyer la commande",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Obtenir de l'aide",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "La demande de retour (RMA) a été générée"
            },
            MISC: {
                YES: "Oui",
                NO: "Non",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "PRÉ-COMMANDE",
                CANCEL: "Annuler",
                CLOSE: "Fermer",
                SUBMIT: "Soumettre",
                REFRESH: "Rafraîchir"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Un problème s’est produit lors de la récupération des informations relatives à votre commande",
                DESCRIPTION: "Nous sommes désolés ! Nous n’avons pas pu récupérer les informations relatives à votre commande. Veuillez réessayer.",
                HELP_MESSAGE: "Ce message continue d’apparaître ? Rendez-vous sur"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE INTROUVABLE",
                DESCRIPTION: "Nous sommes désolés ! La page que vous recherchez n’existe pas, ou est temporairement indisponible.",
                HELP_MESSAGE: "Ce message continue d’apparaître ? Rendez-vous sur"
            },
            DATA_CONFLICT: {
                HEADING: "Mises à jour disponibles pour la commande",
                SUB_HEADING:
                    "Les informations sur la commande ont été mises à jour. Veuillez rafraîchir la page de la commande pour afficher les dernières informations."
            }
        }
    },
    NL: {
        NL: {
            SEARCH_PAGE: {
                HEADING: "Mijn bestelling bekijken",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Bestelnummer",
                    ERROR_REQUIRED: "Bestelnummer is vereist",
                    ERROR_INVALID_FORMAT: "Bestelnummer is ongeldig"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "E-mailadres",
                    ERROR_REQUIRED: "E-mailadres is vereist",
                    ERROR_INVALID: "E-mailadres is ongeldig"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Mijn bestelnummer vergeten",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Bestelling niet gevonden"
                },
                SEARCH_BUTTON_TEXT: "Bestelling bekijken"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Mijn bestelnummer vergeten",
                SUBHEADING: "Voer uw e-mailadres in.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "E-mailadres",
                    ERROR_REQUIRED: "E-mailadres is vereist",
                    ERROR_INVALID: "E-mailadres is ongeldig"
                },
                SEND_BUTTON_TEXT: "E-mail verzenden",
                BACK_BUTTON_TEXT: "Terug",
                EMAIL_SENT: "Er is een e-mail verzonden met een overzicht van de bestelling.",
                EMAIL_NOT_FOUND: "Geen bestellingen voor dit e-mailadres"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Bestelling",
                    ORDERED_ON: "Besteld op",
                    BACK_TO_SEARCH: "Terug naar zoeken"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Verzendadres"
                    },
                    TRACKING: {
                        HEADING: "Trackinginformatie",
                        TRACKING_BUTTON_MESSAGE: "Mijn zending volgen",
                        SHIPMENT_PENDING_MESSAGE: "Wacht op verzending"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Samenvatting van de bestelling",
                        ITEMS_SUBTOTAL_TITLE: "Subtotaal artikel(en)",
                        SHIPPING_TITLE: "Verzending en behandeling",
                        DISCOUNT_TITLE: "Korting",
                        TAXES_TITLE: "Totaal belastingen",
                        REFUND_TITLE: "Terugbetaling",
                        GRAND_TOTAL_TITLE: "Eindtotaal"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "AANGEMAAKT",
                            ACTIVE: "AANGEMAAKT"
                        },
                        AUTHORIZED: {
                            COMPLETED: "GEAUTORISEERD",
                            ACTIVE: "MACHTIGEN"
                        },
                        CANCELLED: {
                            COMPLETED: "GEANNULEERD",
                            ACTIVE: "GEANNULEERD"
                        },
                        PROCESSED: {
                            COMPLETED: "VERWERKT",
                            ACTIVE: "VERWERKEN"
                        },
                        SHIPPED: {
                            COMPLETED: "VERZONDEN",
                            ACTIVE: "VERZENDEN"
                        },
                        DELIVERED: {
                            COMPLETED: "GELEVERD",
                            ACTIVE: "BEZORGEN"
                        },
                        RETURNED: {
                            COMPLETED: "TERUGGEZONDEN",
                            ACTIVE: "RETOURNEREN"
                        },
                        REFUNDED: {
                            COMPLETED: "TERUGBETAALD",
                            ACTIVE: "TERUGBETALEN"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Deze bestelling is geannuleerd op"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Deze bestelling is terugbetaald"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Wachtend op inning van fondsen bij financiële instelling"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Terugbetaalde artikelen"
                    },
                    VIEW_ITEM: "Artikel bekijken"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "Ga voor overige vragen naar"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Bestelling annuleren",
                        SUBHEADING: "Weet u zeker dat u uw bestelling wilt annuleren?",
                        ERROR_FAILED: "Er was een probleem met het annuleren van de bestelling.",
                        SUCCESS_MESSAGE: "Bestelling is geannuleerd.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Artikelen annuleren",
                        SUBHEADING: "Selecteer artikelen die je wilt annuleren.",
                        ERROR_FAILED: "Er is een probleem opgetreden met het annuleren van artikelen.",
                        ERROR_CALCULATION_FAILED: "Er is een probleem opgetreden met het berekenen van een terugbetaling.",
                        SUCCESS_MESSAGE: "Artikelen zijn geannuleerd.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Bestelling is geannuleerd.",
                        SELECT_ALL_ITEMS: "Alle artikelen selecteren",
                        CONFIRMATION: {
                            HEADING: "Artikelen annuleren",
                            SUBHEADING_CANCEL_ITEMS: "Weet je zeker dat je de geselecteerde artikelen wilt annuleren?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Weet u zeker dat u uw bestelling wilt annuleren?"
                        },
                        ITEMS_HEADER: "Artikelen",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Er is minimaal één artikel vereist"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reden",
                    ERRORS: {
                        REASON_REQUIRED: "Je moet een reden opgeven"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Verkeerd artikel gekocht",
                        NO_LONGER_NEEDED: "Niet meer nodig",
                        BETTER_PRICE: "Beschikbaar tegen lagere prijs",
                        MISTAKE: "Bestelling is per ongeluk geplaatst"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Overzicht terugbetaling",
                        ITEMS_SUBTOTAL_TITLE: "Subtotaal artikel(en)",
                        SHIPPING_TITLE: "Verzending en behandeling",
                        DISCOUNT_TITLE: "Korting",
                        TAXES_TITLE: "Totaal belastingen",
                        REFUND_TOTAL_TITLE: "Totale terugbetaling"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Bestelling retourneren",
                        SUBHEADING: "Weet je zeker dat je de bestelling wilt retourneren?",
                        ERROR_FAILED: "Er is een probleem opgetreden bij het aanmaken van een retourverzoek.",
                        SUCCESS_MESSAGE: "Er is een retourverzoek aangemaakt.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Artikelen retourneren",
                        SUBHEADING: "Selecteer de artikelen die je wilt retourneren.",
                        ERROR_FAILED: "Er is een probleem opgetreden bij het aanmaken van een retourverzoek.",
                        ERROR_CALCULATION_FAILED: "Er is een probleem opgetreden met het berekenen van het terug te betalen bedrag.",
                        SUCCESS_MESSAGE: "Er is een retourverzoek aangemaakt.",
                        SELECT_ALL_ITEMS: "Alle artikelen selecteren",
                        CONFIRMATION: {
                            HEADING: "Artikelen retourneren",
                            SUBHEADING: "Weet je zeker dat je geselecteerde artikelen wilt retourneren?"
                        },
                        ITEMS_HEADER: "Artikelen",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Er is minimaal één artikel vereist"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reden",
                    ERRORS: {
                        REASON_REQUIRED: "Reden is vereist"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Verkeerde artikel gekocht",
                        NO_LONGER_NEEDED: "Niet langer nodig",
                        BETTER_PRICE: "Betere prijs beschikbaar",
                        MISTAKE: "Bestelling per ongeluk geplaatst"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Overzicht terugbetaling",
                        ITEMS_SUBTOTAL_TITLE: "Subtotaal artikel(en)",
                        SHIPPING_TITLE: "Verzending en behandeling",
                        DISCOUNT_TITLE: "Korting",
                        TAXES_TITLE: "Totaal belastingen",
                        REFUND_TOTAL_TITLE: "Totale terugbetaling"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Bestelfactuur maken",
                    SUBHEADING: "Voer optionele belastinggegevens in.",
                    SUCCESS_MESSAGE: "Bestelfactuur is naar het e-mailadres verzonden.",
                    ERROR_FAILED: "Bestelfactuur kon niet worden gemaakt.",
                    ADDITIONAL_TAX_INFO_HEADER: "Aanvullende belastinggegevens"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Gerelateerde artikelen",
                        SUB_HEADING: "Koop voor jou aanbevolen artikelen."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Aanbevolen artikelen",
                        SUB_HEADING: "Bekijk andere voor jou beschikbare artikelen."
                    }
                },
                MENU: {
                    INVOICE: "Factuur",
                    CANCEL_ITEMS: "Artikelen annuleren",
                    CANCEL_ORDER: "Bestelling annuleren",
                    RETURN_ITEMS: "Artikelen retourneren",
                    RETURN_ORDER: "Bestelling retourneren",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Hulp vragen",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "Er is een RMA-verzoek aangemaakt"
            },
            MISC: {
                YES: "Ja",
                NO: "Nee",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "VOORUITBESTELLEN",
                CANCEL: "Annuleren",
                CLOSE: "Sluiten",
                SUBMIT: "Verzenden",
                REFRESH: "Vernieuwen"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Er is een probleem opgetreden bij het ophalen van jouw bestelgegevens",
                DESCRIPTION: "Sorry! We konden geen informatie over jouw bestelling ophalen. Probeer het opnieuw.",
                HELP_MESSAGE: "Blijf je dit bericht zien? Ga naar"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGINA NIET GEVONDEN",
                DESCRIPTION: "Sorry! De pagina die je probeert te vinden bestaat niet of is tijdelijk niet beschikbaar.",
                HELP_MESSAGE: "Blijf je dit bericht zien? Ga naar"
            },
            DATA_CONFLICT: {
                HEADING: "Updates over bestelling beschikbaar",
                SUB_HEADING: "De bestelinformatie is bijgewerkt.Vernieuw de bestelpagina voor de meest actuele informatie."
            }
        }
    },
    RKBTEST: {
        EN: {
            SEARCH_PAGE: {
                HEADING: "View my order",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Order Number",
                    ERROR_REQUIRED: "Order number is required",
                    ERROR_INVALID_FORMAT: "Invalid format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Forgot your order number",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Order not found"
                },
                SEARCH_BUTTON_TEXT: "View"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Forgot my order number",
                SUBHEADING: "Please provide your email address.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                SEND_BUTTON_TEXT: "Send email",
                BACK_BUTTON_TEXT: "Back",
                EMAIL_SENT: "An order summary email has been sent.",
                EMAIL_NOT_FOUND: "No orders for this email address"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Order",
                    ORDERED_ON: "Ordered on",
                    BACK_TO_SEARCH: "Back to search"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Shipping Address"
                    },
                    TRACKING: {
                        HEADING: "Tracking Information",
                        TRACKING_BUTTON_MESSAGE: "Track my shipment",
                        SHIPMENT_PENDING_MESSAGE: "Shipment pending"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Order Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TITLE: "Refund",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATED",
                            ACTIVE: "CREATED"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTHORIZED",
                            ACTIVE: "AUTHORIZING"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELLED",
                            ACTIVE: "CANCELLED"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESSED",
                            ACTIVE: "PROCESSING"
                        },
                        SHIPPED: {
                            COMPLETED: "SHIPPED",
                            ACTIVE: "SHIPPING"
                        },
                        DELIVERED: {
                            COMPLETED: "DELIVERED",
                            ACTIVE: "DELIVERING"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNED",
                            ACTIVE: "RETURNING"
                        },
                        REFUNDED: {
                            COMPLETED: "REFUNDED",
                            ACTIVE: "REFUNDING"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "This order was cancelled on"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "This order was refunded"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Waiting for funds to be collected from finance institution"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Refunded Items"
                    },
                    PROTECTION: {
                        TITLE: "Protection Items"
                    },
                    EGIFTCARDS: {
                        TITLE: "eGift Cards"
                    },
                    VIEW_ITEM: "View item"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "For any other inquiries, please go to"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancel Order",
                        SUBHEADING: "Are you sure you want to cancel your order?",
                        ERROR_FAILED: "There was a problem with order cancelation.",
                        SUCCESS_MESSAGE: "Order has been cancelled.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancel Order Items",
                        SUBHEADING: "Select items you would like to cancel.",
                        ERROR_FAILED: "There was a problem with items cancelation.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Items have been cancelled.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Order has been cancelled.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Cancel Order Items",
                            SUBHEADING_CANCEL_ITEMS: "Are you sure you want to cancel selected items?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Are you sure you want to cancel your order?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Return Order",
                        SUBHEADING: "Are you sure you want to return your order?",
                        ERROR_FAILED: "There was a problem with creating order return request.",
                        SUCCESS_MESSAGE: "Return order request was created.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Return Order Items",
                        SUBHEADING: "Select items you would like to return.",
                        ERROR_FAILED: "There was a problem with creating items return request.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Return items request was created.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Return Order Items",
                            SUBHEADING: "Are you sure you want to return selected items?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generate Order Invoice",
                    SUBHEADING: "Please input any optional tax information.",
                    SUCCESS_MESSAGE: "Order invoice has been sent to your email address.",
                    ERROR_FAILED: "Failed to generate order invoice.",
                    ADDITIONAL_TAX_INFO_HEADER: "Additional Tax Info"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Related Items",
                        SUB_HEADING: "Shop for items recommended to you."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Recommended Items",
                        SUB_HEADING: "Browse for more items available for you."
                    }
                },
                MENU: {
                    INVOICE: "Invoice",
                    CANCEL_ITEMS: "Cancel Items",
                    CANCEL_ORDER: "Cancel Order",
                    RETURN_ITEMS: "Return Items",
                    RETURN_ORDER: "Return Order",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Request Assistance",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA request was created"
            },
            MISC: {
                YES: "Yes",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Preorder",
                CANCEL: "Cancel",
                CLOSE: "Close",
                SUBMIT: "Submit",
                REFRESH: "Refresh"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "There was a problem getting your order information",
                DESCRIPTION: "Sorry! We were unable to get information about your order. Please try again.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE NOT FOUND",
                DESCRIPTION: "Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            DATA_CONFLICT: {
                HEADING: "Order Updates Available",
                SUB_HEADING: "Order information has been updated. Please refresh the order page to view the latest information"
            }
        }
    },
    EU: {
        EN: {
            SEARCH_PAGE: {
                HEADING: "View my order",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Order Number",
                    ERROR_REQUIRED: "Order number is required",
                    ERROR_INVALID_FORMAT: "Invalid format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Forgot your order number",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Order not found"
                },
                SEARCH_BUTTON_TEXT: "View"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Forgot my order number",
                SUBHEADING: "Please provide your email address.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Email Address",
                    ERROR_REQUIRED: "Email address is required",
                    ERROR_INVALID: "Email address is invalid"
                },
                SEND_BUTTON_TEXT: "Send email",
                BACK_BUTTON_TEXT: "Back",
                EMAIL_SENT: "An order summary email has been sent.",
                EMAIL_NOT_FOUND: "No orders for this email address"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Order",
                    ORDERED_ON: "Ordered on",
                    BACK_TO_SEARCH: "Back to search"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Shipping Address"
                    },
                    TRACKING: {
                        HEADING: "Tracking Information",
                        TRACKING_BUTTON_MESSAGE: "Track my shipment",
                        SHIPMENT_PENDING_MESSAGE: "Shipment pending"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Order Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TITLE: "Refund",
                        GRAND_TOTAL_TITLE: "Grand Total"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATED",
                            ACTIVE: "CREATED"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTHORIZED",
                            ACTIVE: "AUTHORIZING"
                        },
                        CANCELLED: {
                            COMPLETED: "CANCELLED",
                            ACTIVE: "CANCELLED"
                        },
                        PROCESSED: {
                            COMPLETED: "PROCESSED",
                            ACTIVE: "PROCESSING"
                        },
                        SHIPPED: {
                            COMPLETED: "SHIPPED",
                            ACTIVE: "SHIPPING"
                        },
                        DELIVERED: {
                            COMPLETED: "DELIVERED",
                            ACTIVE: "DELIVERING"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNED",
                            ACTIVE: "RETURNING"
                        },
                        REFUNDED: {
                            COMPLETED: "REFUNDED",
                            ACTIVE: "REFUNDING"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "This order was cancelled on"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "This order was refunded"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Waiting for funds to be collected from finance institution"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Refunded Items"
                    },
                    PROTECTION: {
                        TITLE: "Protection Items"
                    },
                    EGIFTCARDS: {
                        TITLE: "eGift Cards"
                    },
                    VIEW_ITEM: "View item"
                },
                FOOTER_SECTION: {
                    OTHER_INQUIRIES: "For any other inquiries, please go to"
                },
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Cancel Order",
                        SUBHEADING: "Are you sure you want to cancel your order?",
                        ERROR_FAILED: "There was a problem with order cancelation.",
                        SUCCESS_MESSAGE: "Order has been cancelled.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Cancel Order Items",
                        SUBHEADING: "Select items you would like to cancel.",
                        ERROR_FAILED: "There was a problem with items cancelation.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Items have been cancelled.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Order has been cancelled.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Cancel Order Items",
                            SUBHEADING_CANCEL_ITEMS: "Are you sure you want to cancel selected items?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Are you sure you want to cancel your order?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Return Order",
                        SUBHEADING: "Are you sure you want to return your order?",
                        ERROR_FAILED: "There was a problem with creating order return request.",
                        SUCCESS_MESSAGE: "Return order request was created.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Return Order Items",
                        SUBHEADING: "Select items you would like to return.",
                        ERROR_FAILED: "There was a problem with creating items return request.",
                        ERROR_CALCULATION_FAILED: "There was a problem with refund calculation.",
                        SUCCESS_MESSAGE: "Return items request was created.",
                        SELECT_ALL_ITEMS: "Select all items",
                        CONFIRMATION: {
                            HEADING: "Return Order Items",
                            SUBHEADING: "Are you sure you want to return selected items?"
                        },
                        ITEMS_HEADER: "Items",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "At least one item is required"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Reason",
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Wrong item purchased",
                        NO_LONGER_NEEDED: "No longer needed",
                        BETTER_PRICE: "Better price available",
                        MISTAKE: "Order placed by mistake"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Refund Summary",
                        ITEMS_SUBTOTAL_TITLE: "Item(s) Subtotal",
                        SHIPPING_TITLE: "Shipping and Handling",
                        DISCOUNT_TITLE: "Discount",
                        TAXES_TITLE: "Total Taxes",
                        REFUND_TOTAL_TITLE: "Refund Total"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generate Order Invoice",
                    SUBHEADING: "Please input any optional tax information.",
                    SUCCESS_MESSAGE: "Order invoice has been sent to your email address.",
                    ERROR_FAILED: "Failed to generate order invoice.",
                    ADDITIONAL_TAX_INFO_HEADER: "Additional Tax Info"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Related Items",
                        SUB_HEADING: "Shop for items recommended to you."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Recommended Items",
                        SUB_HEADING: "Browse for more items available for you."
                    }
                },
                MENU: {
                    INVOICE: "Invoice",
                    CANCEL_ITEMS: "Cancel Items",
                    CANCEL_ORDER: "Cancel Order",
                    RETURN_ITEMS: "Return Items",
                    RETURN_ORDER: "Return Order",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Request Assistance",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA request was created"
            },
            MISC: {
                YES: "Yes",
                NO: "No",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Preorder",
                CANCEL: "Cancel",
                CLOSE: "Close",
                SUBMIT: "Submit",
                REFRESH: "Refresh"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "There was a problem getting your order information",
                DESCRIPTION: "Sorry! We were unable to get information about your order. Please try again.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGE NOT FOUND",
                DESCRIPTION: "Sorry! The page you're trying to find doesn't exist, or is temporarily unavailable.",
                HELP_MESSAGE: "Keep seeing this message? Go to"
            },
            DATA_CONFLICT: {
                HEADING: "Order Updates Available",
                SUB_HEADING: "Order information has been updated. Please refresh the order page to view the latest information"
            }
        },
        CS: {
            SEARCH_PAGE: {
                HEADING: "Zobrazit moji objednávku",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Objednací číslo",
                    ERROR_REQUIRED: "Je vyžadováno číslo objednávky",
                    ERROR_INVALID_FORMAT: "Neplatný formát"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "E-mailová adresa",
                    ERROR_REQUIRED: "Je vyžadována e-mailová adresa",
                    ERROR_INVALID: "E-mailová adresa je neplatná"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Zapomněl/a jste číslo objednávky",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Objednávka nebyla nalezena"
                },
                SEARCH_BUTTON_TEXT: "Zobrazit"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Zapomněl/a jsem číslo objednávky",
                SUBHEADING: "Uveďte prosím svoji e-mailovou adresu.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "E-mailová adresa",
                    ERROR_REQUIRED: "Je vyžadována e-mailová adresa",
                    ERROR_INVALID: "E-mailová adresa je neplatná"
                },
                SEND_BUTTON_TEXT: "Odeslat e-mail",
                BACK_BUTTON_TEXT: "Zpět",
                EMAIL_SENT: "Byl odeslán e-mail se shrnutím objednávky",
                EMAIL_NOT_FOUND: "Žádné objednávky pro tuto e-mailovou adresu"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Objednávka",
                    ORDERED_ON: "Objednáno dne",
                    BACK_TO_SEARCH: "Zpět na vyhledávání"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Dodací Adresa"
                    },
                    TRACKING: {
                        HEADING: "Informace o Sledování",
                        TRACKING_BUTTON_MESSAGE: "Sledování mé zásilky",
                        SHIPMENT_PENDING_MESSAGE: "Zásilka čeká na vyřízení"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Přehled Objednávek",
                        ITEMS_SUBTOTAL_TITLE: "Položka(y) Mezisoučet",
                        SHIPPING_TITLE: "Přeprava a Manipulace",
                        DISCOUNT_TITLE: "Sleva",
                        TAXES_TITLE: "Daně Celkem",
                        REFUND_TITLE: "Vrácení Peněz",
                        GRAND_TOTAL_TITLE: "Celkový Součet"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "VYTVOŘENO",
                            ACTIVE: "VYTVOŘENO"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTORIZOVÁNO",
                            ACTIVE: "SCHVÁLENÍ"
                        },
                        CANCELLED: {
                            COMPLETED: "ZRUŠENO",
                            ACTIVE: "ZRUŠENO"
                        },
                        PROCESSED: {
                            COMPLETED: "ZPRACOVÁNO",
                            ACTIVE: "ZPRACOVÁNÍ"
                        },
                        SHIPPED: {
                            COMPLETED: "ODESLÁNO",
                            ACTIVE: "DOPRAVA"
                        },
                        DELIVERED: {
                            COMPLETED: "DORUČENO",
                            ACTIVE: "DORUČENÍ"
                        },
                        RETURNED: {
                            COMPLETED: "NAVRÁCENO",
                            ACTIVE: "VRÁCENÍ"
                        },
                        REFUNDED: {
                            COMPLETED: "VRÁCENÁ PLATBA",
                            ACTIVE: "REFUNDACE"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Tato objednávka byla zrušena dne"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Tato objednávka byla vrácena"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Čekání na získání finančních prostředků od finanční instituce"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Vrácené položky"
                    },
                    VIEW_ITEM: "Zobrazit položku"
                },
                FOOTER_SECTION: {},
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Zrušit Objednávku",
                        SUBHEADING: "Jste si jisti, že chcete zrušit objednávku?",
                        ERROR_FAILED: "Vyskytl se problém se zrušením objednávky.",
                        SUCCESS_MESSAGE: "Objednávka byla zrušena.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Zrušit Položky Objednávku",
                        SUBHEADING: "Vyberte položky, které chcete zrušit.",
                        ERROR_FAILED: "Vyskytl se problém se zrušením položek.",
                        ERROR_CALCULATION_FAILED: "Vyskytl se problém s výpočtem náhrady.",
                        SUCCESS_MESSAGE: "Položky byly zrušeny.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Objednávka byla zrušena.",
                        SELECT_ALL_ITEMS: "Vyberte všechny položky",
                        CONFIRMATION: {
                            HEADING: "Zrušit Položky Objednávku",
                            SUBHEADING_CANCEL_ITEMS: "Jste si jisti, že chcete zrušit vybrané položky?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Jste si jisti, že chcete zrušit objednávku?"
                        },
                        ITEMS_HEADER: "Položky",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Je vyžadována alespoň jedna položka"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Důvod",
                    ERRORS: {
                        REASON_REQUIRED: "Je vyžadován důvod"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Zakoupená nesprávná položka",
                        NO_LONGER_NEEDED: "Již není potřeba",
                        BETTER_PRICE: "Lepší dostupná cena",
                        MISTAKE: "Omylem zadaná objednávka"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Přehled Vrácení Peněz",
                        ITEMS_SUBTOTAL_TITLE: "Položka(y) Mezisoučet",
                        SHIPPING_TITLE: "Doprava a Doručení",
                        DISCOUNT_TITLE: "Sleva",
                        TAXES_TITLE: "Daně Celkem",
                        REFUND_TOTAL_TITLE: "Vrácení Peněz Celkem"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Vrátit Objednávku",
                        SUBHEADING: "Jste si jisti, že chcete svou objednávku vrátit?",
                        ERROR_FAILED: "Při vytváření požadavku na vrácení objednávky došlo k problému.",
                        SUCCESS_MESSAGE: "Byla vytvořena žádost o vrácení objednávky.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Vrácení Objednaných Položek",
                        SUBHEADING: "Vyberte položky, které chcete vrátit.",
                        ERROR_FAILED: "Při vytváření požadavku na vrácení objednávky došlo k problému.",
                        ERROR_CALCULATION_FAILED: "Vyskytl se problém s výpočtem náhrady.",
                        SUCCESS_MESSAGE: "Byl vytvořen požadavek na vrácení položek.",
                        SELECT_ALL_ITEMS: "Vyberte všechny položky",
                        CONFIRMATION: {
                            HEADING: "Vrácení objednaných položek",
                            SUBHEADING: "Jste si jisti, že chcete vybrané položky vrátit?"
                        },
                        ITEMS_HEADER: "Položky",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Je vyžadována alespoň jedna položka"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Důvod",
                    ERRORS: {
                        REASON_REQUIRED: "Je vyžadován důvod"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Zakoupená nesprávná položka",
                        NO_LONGER_NEEDED: "Již není potřeba",
                        BETTER_PRICE: "Lepší dostupná cena",
                        MISTAKE: "Omylem zadaná objednávka"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Přehled Vrácení Peněz",
                        ITEMS_SUBTOTAL_TITLE: "Položka(y) Mezisoučet",
                        SHIPPING_TITLE: "Doprava a Doručení",
                        DISCOUNT_TITLE: "Sleva",
                        TAXES_TITLE: "Daně Celkem",
                        REFUND_TOTAL_TITLE: "Vrácení Peněz Celkem"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generování Faktury Objednávky",
                    SUBHEADING: "Zadejte prosím všechny nepovinné daňové údaje.",
                    SUCCESS_MESSAGE: "Faktura za objednávku byla odeslána na vaši e-mailovou adresu.",
                    ERROR_FAILED: "Nepodařilo se vygenerovat fakturu za objednávku.",
                    ADDITIONAL_TAX_INFO_HEADER: "Další daňové informace"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Související Položky",
                        SUB_HEADING: "Nakupujte položky, které vám byly doporučeny."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Doporučené Položky",
                        SUB_HEADING: "Projděte si další položky, které jsou pro vás k dispozici."
                    }
                },
                MENU: {
                    INVOICE: "Faktura",
                    CANCEL_ITEMS: "Zrušit Položky",
                    CANCEL_ORDER: "Zrušit Objednávku",
                    RETURN_ITEMS: "Vrátit Položky",
                    RETURN_ORDER: "Vrátit Objednávku",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Žádost o Pomoc",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "Byl vytvořen požadavek RMA"
            },
            MISC: {
                YES: "Ano",
                NO: "Ne",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Předobjednávka",
                CANCEL: "Zrušit",
                CLOSE: "Zavřít",
                SUBMIT: "Odeslat",
                REFRESH: "Obnovit"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Při získávání informací o vaší objednávce došlo k problému",
                DESCRIPTION: "Omlouváme se! Informace o vaší objednávce se nám nepodařilo získat. Zkuste to prosím znovu.",
                HELP_MESSAGE: "Stále vidíte tuto zprávu? Přejděte na"
            },
            NOT_FOUND_PAGE: {
                TITLE: "STRÁNKA NEBYLA NALEZENA",
                DESCRIPTION: "Omlouváme se! Stránka, kterou se snažíte najít, neexistuje nebo je dočasně nedostupná.",
                HELP_MESSAGE: "Stále vidíte tuto zprávu? Přejděte na"
            },
            DATA_CONFLICT: {
                HEADING: "Dostupné aktualizace objednávek",
                SUB_HEADING: "Informace o objednávce byly aktualizovány. Chcete-li zobrazit nejnovější informace, obnovte prosím stránku s objednávkou."
            }
        },
        PL: {
            SEARCH_PAGE: {
                HEADING: "Wyświetl moje zamówienie",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Numer zamówienia",
                    ERROR_REQUIRED: "Numer zamówienia jest wymagany",
                    ERROR_INVALID_FORMAT: "Nieprawidłowy format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adres e-mail",
                    ERROR_REQUIRED: "Adres e-mail jest wymagany",
                    ERROR_INVALID: "Adres e-mail jest nieprawidłowy"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Nie pamiętasz numeru zamówienia?",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Nie znaleziono zamówienia"
                },
                SEARCH_BUTTON_TEXT: "Wyświetl"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Nie pamiętam numeru zamówienia",
                SUBHEADING: "Podaj swój adres e-mail.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adres e-mail",
                    ERROR_REQUIRED: "Adres e-mail jest wymagany",
                    ERROR_INVALID: "Adres e-mail jest nieprawidłowy"
                },
                SEND_BUTTON_TEXT: "Wyślij e-mail",
                BACK_BUTTON_TEXT: "Wróć",
                EMAIL_SENT: "E-mail z podsumowaniem zamówienia został wysłany.",
                EMAIL_NOT_FOUND: "Brak zamówień na ten adres e-mail"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Zamówienie",
                    ORDERED_ON: "Zamówiono dnia",
                    BACK_TO_SEARCH: "Powrót do wyszukiwania"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Adres Wysyłki"
                    },
                    TRACKING: {
                        HEADING: "Informacje o Śledzeniu Zamówienia",
                        TRACKING_BUTTON_MESSAGE: "Śledź moją wysyłkę",
                        SHIPMENT_PENDING_MESSAGE: "Wysyłka w toku"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Podsumowanie Zamówienia",
                        ITEMS_SUBTOTAL_TITLE: "Suma Częściowa Produktów",
                        SHIPPING_TITLE: "Wysyłka i Obsługa",
                        DISCOUNT_TITLE: "Zniżka",
                        TAXES_TITLE: "Podatki Ogółem",
                        REFUND_TITLE: "Zwrot Środków",
                        GRAND_TOTAL_TITLE: "Łączna Suma"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "UTWORZONE",
                            ACTIVE: "UTWORZONE"
                        },
                        AUTHORIZED: {
                            COMPLETED: "ZATWIERDZONE",
                            ACTIVE: "AUTORYZACJA"
                        },
                        CANCELLED: {
                            COMPLETED: "ANULOWANE",
                            ACTIVE: "ANULOWANE"
                        },
                        PROCESSED: {
                            COMPLETED: "PRZETWORZONE",
                            ACTIVE: "PRZETWARZANIE"
                        },
                        SHIPPED: {
                            COMPLETED: "WYSŁANE",
                            ACTIVE: "WYSYŁKA"
                        },
                        DELIVERED: {
                            COMPLETED: "DOSTARCZONE",
                            ACTIVE: "DOSTAWA"
                        },
                        RETURNED: {
                            COMPLETED: "ZWRÓCONE",
                            ACTIVE: "ZWROT TOWARU"
                        },
                        REFUNDED: {
                            COMPLETED: "ZWRÓCONO ŚRODKI",
                            ACTIVE: "ZWROT PIENIĘDZY"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "To zamówienie zostało anulowane dnia"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Dokonano zwrotu środków za to zamówienie"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Oczekiwanie na pobranie środków z instytucji finansowej"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Zwrócone produkty"
                    },
                    VIEW_ITEM: "Wyświetl produkt"
                },
                FOOTER_SECTION: {},
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Anuluj Zamówienie",
                        SUBHEADING: "Czy na pewno chcesz anulować zamówienie?",
                        ERROR_FAILED: "Wystąpił problem z anulowaniem zamówienia.",
                        SUCCESS_MESSAGE: "Zamówienie zostało anulowane.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Anuluj Produkty z Zamówienia",
                        SUBHEADING: "Wybierz produkty, które chcesz anulować.",
                        ERROR_FAILED: "Wystąpił problem z anulowaniem zamówienia.",
                        ERROR_CALCULATION_FAILED: "Wystąpił problem z obliczeniem środków do zwrotu.",
                        SUCCESS_MESSAGE: "Produkty zostały anulowane.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Zamówienie zostało anulowane.",
                        SELECT_ALL_ITEMS: "Wybierz wszystkie produkty",
                        CONFIRMATION: {
                            HEADING: "Anuluj Produkty z Zamówienia",
                            SUBHEADING_CANCEL_ITEMS: "Czy na pewno chcesz anulować wybrane produkty?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Czy na pewno chcesz anulować zamówienie?"
                        },
                        ITEMS_HEADER: "Produkty",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Wymagane jest zaznaczenie co najmniej jednego produktu"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Powód",
                    ERRORS: {
                        REASON_REQUIRED: "Powód jest wymagany"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Kupiono niewłaściwy produkt",
                        NO_LONGER_NEEDED: "Nie jest już potrzebny",
                        BETTER_PRICE: "Dostępna lepsza cena",
                        MISTAKE: "Zamówienie złożone przez pomyłkę"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Podsumowanie Zwrotu Środków",
                        ITEMS_SUBTOTAL_TITLE: "Suma Częściowa Produktów",
                        SHIPPING_TITLE: "Wysyłka i Obsługa",
                        DISCOUNT_TITLE: "Zniżka",
                        TAXES_TITLE: "Podatki Ogółem",
                        REFUND_TOTAL_TITLE: "Całkowity Zwrot Środków"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Zwróć Zamówienie",
                        SUBHEADING: "Czy na pewno chcesz zwrócić zamówienie?",
                        ERROR_FAILED: "Wystąpił problem z utworzeniem wniosku o zwrot zamówienia.",
                        SUCCESS_MESSAGE: "Utworzono wniosek o zwrot zamówienia.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Zwróć Produkty z Zamówienia",
                        SUBHEADING: "Wybierz produkty, które chcesz zwrócić.",
                        ERROR_FAILED: "Wystąpił problem z utworzeniem wniosku o zwrot zamówienia.",
                        ERROR_CALCULATION_FAILED: "Wystąpił problem z obliczeniem środków do zwrotu.",
                        SUCCESS_MESSAGE: "Utworzono wniosek o zwrot produktów.",
                        SELECT_ALL_ITEMS: "Wybierz wszystkie produkty",
                        CONFIRMATION: {
                            HEADING: "Zwróć Produkty z Zamówienia",
                            SUBHEADING: "Czy na pewno chcesz zwrócić wybrane produkty?"
                        },
                        ITEMS_HEADER: "Produkty",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Wymagane jest zaznaczenie co najmniej jednego produktu"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Powód",
                    ERRORS: {
                        REASON_REQUIRED: "Powód jest wymagany"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Kupiono niewłaściwy produkt",
                        NO_LONGER_NEEDED: "Nie jest już potrzebny",
                        BETTER_PRICE: "Dostępna lepsza cena",
                        MISTAKE: "Zamówienie złożone przez pomyłkę"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Podsumowanie Zwrotu Środków",
                        ITEMS_SUBTOTAL_TITLE: "Suma Częściowa Produktów",
                        SHIPPING_TITLE: "Wysyłka i Obsługa",
                        DISCOUNT_TITLE: "Zniżka",
                        TAXES_TITLE: "Podatki Ogółem",
                        REFUND_TOTAL_TITLE: "Całkowity Zwrot Środków"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Wygeneruj Fakturę do Zamówienia",
                    SUBHEADING: "Podaj wszelkie opcjonalne informacje podatkowe.",
                    SUCCESS_MESSAGE: "Faktura za zamówienie została wysłana na Twój adres e-mail.",
                    ERROR_FAILED: "Nie udało się wygenerować faktury za zamówienie.",
                    ADDITIONAL_TAX_INFO_HEADER: "Dodatkowe Informacje Podatkowe"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Powiązane Produkty",
                        SUB_HEADING: "Kupuj polecane Ci produkty."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Polecane Produkty",
                        SUB_HEADING: "Przeglądaj, aby znaleźć więcej produktów dostępnych dla Ciebie."
                    }
                },
                MENU: {
                    INVOICE: "Faktura",
                    CANCEL_ITEMS: "Anuluj produkty",
                    CANCEL_ORDER: "Anuluj zamówienie",
                    RETURN_ITEMS: "Zwróć produkty",
                    RETURN_ORDER: "Zwróć zamówienie",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Poproś o pomoc",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "Utworzono wniosek RMA"
            },
            MISC: {
                YES: "Tak",
                NO: "Nie",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Przedsprzedaż",
                CANCEL: "Anuluj",
                CLOSE: "Zamknij",
                SUBMIT: "Wyślij",
                REFRESH: "Odśwież"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Podczas pobierania informacji o zamówieniu wystąpił problem",
                DESCRIPTION: "Przepraszamy! Nie mogliśmy uzyskać informacji o Twoim zamówieniu. Spróbuj ponownie.",
                HELP_MESSAGE: "Nadal widzisz tę wiadomość? Wejdź na"
            },
            NOT_FOUND_PAGE: {
                TITLE: "STRONA NIEZNALEZIONA",
                DESCRIPTION: "Przepraszamy! Strona, którą próbujesz znaleźć, nie istnieje lub jest tymczasowo niedostępna.",
                HELP_MESSAGE: "Nadal widzisz tę wiadomość? Wejdź na"
            },
            DATA_CONFLICT: {
                HEADING: "Dostępne aktualizacje dot. zamówienia",
                SUB_HEADING: "Informacje o zamówieniu zostały zaktualizowane. Odśwież stronę zamówienia, aby zobaczyć najnowsze informacje"
            }
        },
        RO: {
            SEARCH_PAGE: {
                HEADING: "Vedeți comanda dvs",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Număr comandă",
                    ERROR_REQUIRED: "Este necesar numărul comenzii",
                    ERROR_INVALID_FORMAT: "Format nevalid"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adresă de e-mail",
                    ERROR_REQUIRED: "Este necesară adresa de e-mail",
                    ERROR_INVALID: "Adresa de e-mail nu este validă"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Ați uitat numărul comenzii",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Comanda nu a fost găsită"
                },
                SEARCH_BUTTON_TEXT: "Vizualizați"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Am uitat numărul comenzii mele",
                SUBHEADING: "Menționați adresa dvs. de e-mail.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "Adresă de e-mail",
                    ERROR_REQUIRED: "Este necesară adresa de e-mail",
                    ERROR_INVALID: "Adresa de e-mail nu este validă"
                },
                SEND_BUTTON_TEXT: "Trimitere e-mail",
                BACK_BUTTON_TEXT: "Înapoi",
                EMAIL_SENT: "A fost trimis un e-mail cu sumarul comenzii.",
                EMAIL_NOT_FOUND: "Nu au fost găsite comenzi pentru această adresă de e-mail"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Comandă",
                    ORDERED_ON: "Comandat la",
                    BACK_TO_SEARCH: "Înapoi la căutare"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Adresă de expediere"
                    },
                    TRACKING: {
                        HEADING: "Informații de urmărire",
                        TRACKING_BUTTON_MESSAGE: "Urmărește expedierea mea",
                        SHIPMENT_PENDING_MESSAGE: "Expediere în așteptare"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Sumar comandă",
                        ITEMS_SUBTOTAL_TITLE: "Subtotal articol/articole",
                        SHIPPING_TITLE: "Expediere și manipulare",
                        DISCOUNT_TITLE: "Reducere",
                        TAXES_TITLE: "Total taxe",
                        REFUND_TITLE: "Rambursare",
                        GRAND_TOTAL_TITLE: "Total general"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "CREATĂ",
                            ACTIVE: "CREATĂ"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUTORIZATĂ",
                            ACTIVE: "ÎN CURS DE AUTORIZARE"
                        },
                        CANCELLED: {
                            COMPLETED: "ANULATĂ",
                            ACTIVE: "ANULATĂ"
                        },
                        PROCESSED: {
                            COMPLETED: "PRELUCRATĂ",
                            ACTIVE: "ÎN CURS DE PROCESARE"
                        },
                        SHIPPED: {
                            COMPLETED: "EXPEDIATĂ",
                            ACTIVE: "ÎN CURS DE EXPEDIERE"
                        },
                        DELIVERED: {
                            COMPLETED: "LIVRATĂ",
                            ACTIVE: "ÎN CURS DE LIVRARE"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNATĂ",
                            ACTIVE: "ÎN CURS DE RETURNARE"
                        },
                        REFUNDED: {
                            COMPLETED: "RAMBURSATĂ",
                            ACTIVE: "ÎN CURS DE RAMBURSARE"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Această comandă a fost anulată la"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Această comandă a fost rambursată"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Se așteaptă colectarea fondurilor de la instituția financiară"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Articole rambursate"
                    },
                    VIEW_ITEM: "Vedeți articolul"
                },
                FOOTER_SECTION: {},
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Anulați comanda",
                        SUBHEADING: "Sigur doriți să anulați comanda?",
                        ERROR_FAILED: "S-a produs o problemă la anularea comenzii.",
                        SUCCESS_MESSAGE: "Comanda a fost anulată.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Anulați articolele din comandă",
                        SUBHEADING: "Selectați articolele pe care doriți să le anulați.",
                        ERROR_FAILED: "S-a produs o problemă la anularea articolelor.",
                        ERROR_CALCULATION_FAILED: "S-a produs o problemă la calcularea rambursării.",
                        SUCCESS_MESSAGE: "Articolele au fost anulate.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Comanda a fost anulată.",
                        SELECT_ALL_ITEMS: "Selectați toate articolele",
                        CONFIRMATION: {
                            HEADING: "Anulați articolele din comandă",
                            SUBHEADING_CANCEL_ITEMS: "Sigur doriți să anulați articolele selectate?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Sigur doriți să anulați comanda?"
                        },
                        ITEMS_HEADER: "Articole",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Este necesar cel puțin un articol"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Motiv",
                    ERRORS: {
                        REASON_REQUIRED: "Motivul este obligatoriu"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Achiziționarea unui articol greșit",
                        NO_LONGER_NEEDED: "Nu mai este nevoie de el",
                        BETTER_PRICE: "Am găsit un preț mai bun",
                        MISTAKE: "Comandă plasată din greșeală"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Rezumat rambursare",
                        ITEMS_SUBTOTAL_TITLE: "Subtotal articol/articole",
                        SHIPPING_TITLE: "Expediere și manipulare",
                        DISCOUNT_TITLE: "Reducere",
                        TAXES_TITLE: "Total taxe",
                        REFUND_TOTAL_TITLE: "Total rambursare"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Returnați comanda",
                        SUBHEADING: "Sigur doriți să returnați comanda?",
                        ERROR_FAILED: "S-a produs o problemă la crearea solicitării de returnare a comenzii.",
                        SUCCESS_MESSAGE: "Solicitarea de returnare a comenzii a fost creată.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Returnați articolele din comandă",
                        SUBHEADING: "Selectați articolele pe care doriți să le returnați.",
                        ERROR_FAILED: "S-a produs o problemă la crearea solicitării de returnare a comenzii.",
                        ERROR_CALCULATION_FAILED: "S-a produs o problemă la calcularea rambursării.",
                        SUCCESS_MESSAGE: "A fost creată solicitarea de returnare a articolelor.",
                        SELECT_ALL_ITEMS: "Selectați toate articolele",
                        CONFIRMATION: {
                            HEADING: "Returnați articolele din comandă",
                            SUBHEADING: "Sigur doriți să returnați articolele selectate?"
                        },
                        ITEMS_HEADER: "Articole",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Este necesar cel puțin un articol"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Motiv",
                    ERRORS: {
                        REASON_REQUIRED: "Motivul este obligatoriu"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Achiziționarea unui articol greșit",
                        NO_LONGER_NEEDED: "Nu mai este nevoie de el",
                        BETTER_PRICE: "Am găsit un preț mai bun",
                        MISTAKE: "Comandă plasată din greșeală"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Rezumat rambursare",
                        ITEMS_SUBTOTAL_TITLE: "Subtotal articol/articole",
                        SHIPPING_TITLE: "Expediere și manipulare",
                        DISCOUNT_TITLE: "Reducere",
                        TAXES_TITLE: "Total taxe",
                        REFUND_TOTAL_TITLE: "Total rambursare"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Generați factură pentru comandă",
                    SUBHEADING: "Introduceți orice informații fiscale opționale.",
                    SUCCESS_MESSAGE: "Factura aferentă comenzii a fost trimisă la adresa dvs. de e-mail.",
                    ERROR_FAILED: "Nu s-a putut genera factura pentru comanda dvs.",
                    ADDITIONAL_TAX_INFO_HEADER: "Informații fiscale suplimentare"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Articole conexe",
                        SUB_HEADING: "Cumpărați articolele recomandate pentru dvs."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Articole recomandate",
                        SUB_HEADING: "Răsfoiți mai multe articole disponibile pentru dvs."
                    }
                },
                MENU: {
                    INVOICE: "Factură",
                    CANCEL_ITEMS: "Anulați articolele",
                    CANCEL_ORDER: "Anulați comanda",
                    RETURN_ITEMS: "Returnați articolele",
                    RETURN_ORDER: "Returnați comanda",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Solicitați asistență",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "A fost creată solicitarea RMA"
            },
            MISC: {
                YES: "Da",
                NO: "Nu",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Faceți o precomandă",
                CANCEL: "Anulați",
                CLOSE: "Închideți",
                SUBMIT: "Transmiteți",
                REFRESH: "Reîmprospătați"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "S-a produs o problemă la preluarea informațiilor despre comanda dvs.",
                DESCRIPTION: "Ne pare rău! Nu am putut prelua informații despre comanda dvs. Vă rugăm să reîncercați.",
                HELP_MESSAGE: "Continuați să vedeți acest mesaj? Accesați"
            },
            NOT_FOUND_PAGE: {
                TITLE: "PAGINA NU A FOST GĂSITĂ",
                DESCRIPTION: "Ne pare rău! Pagina pe care încercați să o găsiți nu există sau este indisponibilă temporar.",
                HELP_MESSAGE: "Continuați să vedeți acest mesaj? Accesați"
            },
            DATA_CONFLICT: {
                HEADING: "Sunt disponibile actualizări privind comanda",
                SUB_HEADING: "Informațiile despre comandă au fost actualizate. Reîmprospătați pagina comenzii pentru a vedea cele mai recente informații"
            }
        },
        SE: {
            SEARCH_PAGE: {
                HEADING: "Visa min beställning",
                ORDER_NUMBER_INPUT: {
                    HEADER: "Beställningsnummer",
                    ERROR_REQUIRED: "Beställningsnummer krävs",
                    ERROR_INVALID_FORMAT: "Ogiltigt format"
                },
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "E-postadress",
                    ERROR_REQUIRED: "E-postadress måste anges",
                    ERROR_INVALID: "E-postadress är ogiltig"
                },
                FORGOT_YOUR_ORDER_NUMBER: "Glömt ditt beställningsnummer",
                FEEDBACK_MESSAGE: {
                    ORDER_NOT_FOUND: "Beställningen hittades inte"
                },
                SEARCH_BUTTON_TEXT: "Visa"
            },
            FORGOT_ORDER_NUMBER_PAGE: {
                HEADING: "Glömt mitt beställningsnummer",
                SUBHEADING: "Ange din e-postadress.",
                EMAIL_ADDRESS_INPUT: {
                    HEADER: "E-postadress",
                    ERROR_REQUIRED: "E-postadress måste anges",
                    ERROR_INVALID: "E-postadress är ogiltig"
                },
                SEND_BUTTON_TEXT: "Skicka e-post",
                BACK_BUTTON_TEXT: "Tillbaka",
                EMAIL_SENT: "Ett e-postmeddelande med en sammanfattning av beställningen har skickats.",
                EMAIL_NOT_FOUND: "Inga beställningar hittades för den här e-postadressen"
            },
            ORDER_PAGE: {
                HEADER_SECTION: {
                    HEADING: "Beställning",
                    ORDERED_ON: "Beställd den",
                    BACK_TO_SEARCH: "Tillbaka till sökning"
                },
                SHIPPING_TRACKING_ORDER_SUMMARY_SECTION: {
                    SHIPPING: {
                        HEADING: "Leveransadress"
                    },
                    TRACKING: {
                        HEADING: "Spårnings information",
                        TRACKING_BUTTON_MESSAGE: "Spåra min försändelse",
                        SHIPMENT_PENDING_MESSAGE: "Leverans väntar"
                    },
                    ORDER_SUMMARY: {
                        HEADING: "Beställnings sammanfattning",
                        ITEMS_SUBTOTAL_TITLE: "Objekt delsumma",
                        SHIPPING_TITLE: "Frakt och hantering",
                        DISCOUNT_TITLE: "Rabatt",
                        TAXES_TITLE: "Totalt skatter",
                        REFUND_TITLE: "Återbetalning",
                        GRAND_TOTAL_TITLE: "Totalsumma"
                    }
                },
                STATUS_BAR_SECTION: {
                    STATUSES: {
                        CREATED: {
                            COMPLETED: "SKAPAD",
                            ACTIVE: "SKAPAD"
                        },
                        AUTHORIZED: {
                            COMPLETED: "AUKTORISERAD",
                            ACTIVE: "AUKTORISERAR"
                        },
                        CANCELLED: {
                            COMPLETED: "ANULLERAD",
                            ACTIVE: "ANULLERAD"
                        },
                        PROCESSED: {
                            COMPLETED: "BEARBETAD",
                            ACTIVE: "BEARBETAR"
                        },
                        SHIPPED: {
                            COMPLETED: "SKICKAD",
                            ACTIVE: "LEVERANS"
                        },
                        DELIVERED: {
                            COMPLETED: "LEVERERAD",
                            ACTIVE: "LEVERERAR"
                        },
                        RETURNED: {
                            COMPLETED: "RETURNERAD",
                            ACTIVE: "RETURNERAR"
                        },
                        REFUNDED: {
                            COMPLETED: "ÅTERBETALD",
                            ACTIVE: "ÅTERBETALAR"
                        }
                    }
                },
                CANCELLED_SECTION: {
                    CANCELLED_MESSAGE: "Din order har annullerats den"
                },
                REFUNDED_SECTION: {
                    REFUNDED_MESSAGE: "Din order har återbetalats"
                },
                AUTHORIZED_SECTION: {
                    AUTHORIZED_MESSAGE: "Väntar på att medel ska hämtas från finansinstitutet"
                },
                ITEMS_SECTION: {
                    REFUNDED: {
                        TITLE: "Återbetalda artiklar"
                    },
                    VIEW_ITEM: "Visa artikel"
                },
                FOOTER_SECTION: {},
                CANCEL_SECTION: {
                    CANCEL_ORDER: {
                        HEADING: "Annullera beställning",
                        SUBHEADING: "Är du säker att du vill avbryta din beställning?",
                        ERROR_FAILED: "Det uppstod ett problem med annullering av beställningen..",
                        SUCCESS_MESSAGE: "Beställning has annullerats..",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    CANCEL_ORDER_ITEMS: {
                        HEADING: "Annullera andra artiklar",
                        SUBHEADING: "Välj artiklar du vill annullera.",
                        ERROR_FAILED: "Det uppstod ett problem med annullering av artiklar.",
                        ERROR_CALCULATION_FAILED: "Det uppstod ett problem med beräkningen av återbetalning.",
                        SUCCESS_MESSAGE: "Artiklar har annullerats.",
                        SUCCESS_MESSAGE_FULL_ORDER: "Beställning has annullerats..",
                        SELECT_ALL_ITEMS: "Välj alla artiklar",
                        CONFIRMATION: {
                            HEADING: "Annullera andra artiklar",
                            SUBHEADING_CANCEL_ITEMS: "Är du säker på att du vill annullera valda artiklar?",
                            SUBHEADING_CANCEL_FULL_ORDER: "Är du säker att du vill avbryta din beställning?"
                        },
                        ITEMS_HEADER: "Artiklar",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Minst en artikel krävs"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be cancelled because they are Final Sale"
                    },
                    REASON_HEADER: "Orsak",
                    ERRORS: {
                        REASON_REQUIRED: "Orsak krävs"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Fel artikel köpt",
                        NO_LONGER_NEEDED: "Behövs inte längre",
                        BETTER_PRICE: "Bättre pris tillgängligt",
                        MISTAKE: "Beställdes av misstag"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Återbetalningsöversikt",
                        ITEMS_SUBTOTAL_TITLE: "Objekt delsumma",
                        SHIPPING_TITLE: "Frakt och hantering",
                        DISCOUNT_TITLE: "Rabatt",
                        TAXES_TITLE: "Totalt skatter",
                        REFUND_TOTAL_TITLE: "Återbetalning totalt"
                    }
                },
                RETURN_SECTION: {
                    RETURN_ORDER: {
                        HEADING: "Returnera beställning",
                        SUBHEADING: "Vill du avbryta din beställning?",
                        ERROR_FAILED: "Det uppstod ett problem med att skapa en begäran om retur av beställning.",
                        SUCCESS_MESSAGE: "Returnera beställning-förfrågan skapades.",
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    RETURN_ORDER_ITEMS: {
                        HEADING: "Returnera andra artiklar",
                        SUBHEADING: "Välj artiklar du vill returnera.",
                        ERROR_FAILED: "Det uppstod ett problem med att skapa en begäran om retur av beställning.",
                        ERROR_CALCULATION_FAILED: "Det uppstod ett problem med beräkningen av återbetalning.",
                        SUCCESS_MESSAGE: "Returnera artiklar-förfrågan skapades.",
                        SELECT_ALL_ITEMS: "Välj alla artiklar",
                        CONFIRMATION: {
                            HEADING: "Returnera andra artiklar",
                            SUBHEADING: "Är du säker att du vill returnera valda objekt?"
                        },
                        ITEMS_HEADER: "Artiklar",
                        ERRORS: {
                            CANCEL_ITEMS_REQUIRED: "Minst en artikel krävs"
                        },
                        EGIFTCARDS_PRESENT_MESSAGE: "* Order contains eGift Cards that can not be returned because they are Final Sale"
                    },
                    REASON_HEADER: "Orsak",
                    ERRORS: {
                        REASON_REQUIRED: "Orsak krävs"
                    },
                    REASONS: {
                        WRONG_ITEM_PURCHASED: "Fel artikel köpt",
                        NO_LONGER_NEEDED: "Behövs inte längre",
                        BETTER_PRICE: "Bättre pris tillgängligt",
                        MISTAKE: "Beställdes av misstag"
                    },
                    REFUND_SUMMARY: {
                        HEADING: "Återbetalningsöversikt",
                        ITEMS_SUBTOTAL_TITLE: "Objekt delsumma",
                        SHIPPING_TITLE: "Frakt och hantering",
                        DISCOUNT_TITLE: "Rabatt",
                        TAXES_TITLE: "Totalt skatter",
                        REFUND_TOTAL_TITLE: "Återbetalning totalt"
                    }
                },
                REPLACE_SECTION: {
                    HEADING: "Replace Order Items",
                    SUBHEADING: "Select items you would like to replace.",
                    ERROR_FAILED: "There was a problem with creating items replacement request.",
                    SUCCESS_MESSAGE: "Replacement request was submitted for review.",
                    REASON_HEADER: "Reason",
                    ITEMS_HEADER: "Items",
                    SELECT_ALL_ITEMS: "Select all items",
                    CONFIRMATION: {
                        HEADING: "Replace Order Items",
                        SUBHEADING: "Are you sure you want to replace selected items?"
                    },
                    ERRORS: {
                        REASON_REQUIRED: "Reason is required",
                        CANCEL_ITEMS_REQUIRED: "At least one item is required"
                    },
                    REASONS: {
                        BATTERY_CHARGING_ISSUE: "Battery/Charging Issue",
                        DEFECTIVE_BROKEN_SCREEN_ISSUE: "Defective/Broken Screen",
                        FRONTLIGHT_ISSUE: "Frontlight Issues",
                        FROZEN_ISSUE: "Frozen Device",
                        NETWORK_WIFI_ISSUE: "Network/WIFI Issue",
                        SOFTWARE_UPDATE_ISSUE: "Software Update Issue",
                        USB_PORT_ISSUE: "USB Port Problem",
                        WATERPROOF_ISSUE: "Waterproof Issues",
                        OTHER: "Other"
                    }
                },
                INVOICE_SECTION: {
                    HEADING: "Skapa beställningsfaktura",
                    SUBHEADING: "Ange eventuella valfria skatteuppgifter.",
                    SUCCESS_MESSAGE: "Beställningsfaktura har skickats till din e-postadress.",
                    ERROR_FAILED: "Kunde inte generera beställningsfaktura.",
                    ADDITIONAL_TAX_INFO_HEADER: "Ytterligare skatteinformation"
                },
                EGIFTCARDS_SECTION: {
                    HEADING: "Get eGift Cards Details Email",
                    SUBHEADING: "eGift Cards Details Email will be sent to the email address indicated in the order. Would you like to proceed?",
                    SUCCESS_MESSAGE: "Email has been sent",
                    ERROR_FAILED: "Failed to send eGift Cards email"
                },
                MARKETING: {
                    RELATED_ITEMS: {
                        HEADING: "Relaterade artiklar",
                        SUB_HEADING: "Handla artiklar som rekommenderas till dig."
                    },
                    RECOMMENDED_ITEMS: {
                        HEADING: "Rekommenderade artiklar",
                        SUB_HEADING: "Bläddra efter fler artiklar som är tillgängliga för dig."
                    }
                },
                MENU: {
                    INVOICE: "Faktura",
                    CANCEL_ITEMS: "Annullera artiklar",
                    CANCEL_ORDER: "Annullera beställning",
                    RETURN_ITEMS: "Returnera artiklar",
                    RETURN_ORDER: "Returnera beställning",
                    REPLACE_ITEMS: "Replace Items",
                    REQUEST_ASSISTANCE: "Begär hjälp",
                    SEND_EGIFTCARDS_EMAIL: "Get eGift Cards Details"
                },
                RMA_TITLE: "RMA-förfrågan skapades"
            },
            MISC: {
                YES: "Ja",
                NO: "Nej",
                HELP_LINK: "https://help.kobo.com/hc/requests/new",
                PREORDER: "Förbeställning",
                CANCEL: "Avbryt",
                CLOSE: "Stäng",
                SUBMIT: "Skicka",
                REFRESH: "Uppdatera"
            },
            FETCH_ERROR_PAGE: {
                TITLE: "Det uppstod ett problem med att få din beställningsinformation",
                DESCRIPTION: "Tyvärr! Vi kunde inte få information om din beställning. Försök igen.",
                HELP_MESSAGE: "Fortsätt se detta meddelande? Gå till"
            },
            NOT_FOUND_PAGE: {
                TITLE: "SIDAN HITTADES INTE",
                DESCRIPTION: "Tyvärr! Sidan du försöker hitta existerar inte, eller är tillfälligt otillgänglig.",
                HELP_MESSAGE: "Fortsätt se detta meddelande? Gå till"
            },
            DATA_CONFLICT: {
                HEADING: "Beställningsuppdateringar finns tillgänglig",
                SUB_HEADING: "Din beställningsinformation har uppdaterats. Uppdatera beställningssidan för att se den senaste informationen"
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/_constants/locales.js